<template>
  <!--页面渲染的容器-->
  <div
    :id="`router_page_${routerId}`"
    :style="{ zIndex: index, ...styleObject, ...containerStyleObject }"
    :data-pageid="pageid"
    class="idm_render_engine_page_container idm_page_box"
    :class="
      IDM.setting.applications.themeNamePrefix +
      (typeof themeSetObject === 'object'
        ? JSON.stringify(themeSetObject)
        : themeSetObject)
    "
  >
    <div class="idm_render_engine_page_content" :style="contentStyleObject">
      <!--弹出框容器-->
      <div
        :id="`idm_dialog_wrap_${routerId}`"
        v-show="dialogVisibleStatus"
        class="idm_dialog_wrap_preview"
        :hideing="`${dialogIsHideing ? 'hideing' : ''}`"
      >
        <div
          class="idm_dialog_shade_layer"
          :class="'idm_dialog_shade_layer_' + item.packageid"
          v-for="(item, index) in dialogObjectList"
          :key="index"
          :dialog-id="item.packageid"
          @click="layerClickHandle(item, $event)"
        ></div>
      </div>
      <!--悬浮层容器-->
      <div id="idm_hover_layer_wrap" class="idm_hover_layer_wrap_preview"></div>
      <div
        class="idm_page_root"
        :id="'PAGE_' + PageSettingData.id + '_' + routerId"
        :idm-com-anchor-id="PageSettingData.id"
        ref="idm_page_root"
        :class="`${PageSettingData.id}`"
      ></div>
    </div>
    <transition name="idm_page_user_defined_topbar">
      <div
        v-if="pageUserDefinedStatus && hiddenCustomizationToolBar"
        class="idm_page_user_defined_topbar"
      >
        <div class="idm_page_user_defined_logo">
          <svg
            t="1659591467192"
            class="user-defined-logo-svg"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1396"
            width="32"
            height="32"
          >
            <path
              d="M727.008 487.232l194.016-184.32a99.2 99.2 0 0 0 0-140.288l-48.416-48.416a99.2 99.2 0 0 0-138.464-1.76L544.64 292.384l-184.064-196.64-1.504-1.568a64.832 64.832 0 0 0-91.712-0.384L129.184 231.968a64.8 64.8 0 0 0-1.12 90.144l181.344 193.728-171.456 162.88a99.264 99.264 0 0 0-28.256 49.28l-28.992 123.744a65.632 65.632 0 0 0 82.4 77.92l119.296-35.136a99.744 99.744 0 0 0 40.32-23.232l169.056-160.608 203.616 217.536 1.504 1.568a64.832 64.832 0 0 0 91.712 0.384l138.176-138.176a64.8 64.8 0 0 0 1.12-90.144l-200.896-214.624zM319.424 786.176l-90.112-90.112a31.488 31.488 0 0 0-9.792-6.496L667.104 264.352l94.272 94.272c1.408 1.408 3.168 2.08 4.768 3.168L319.424 786.176zM778.208 158.784a35.2 35.2 0 0 1 49.12 0.64l48.416 48.416c13.76 13.76 13.76 36.032-0.64 50.4l-64.448 61.216c-1.28-2.08-2.24-4.288-4.064-6.112l-93.12-93.12 64.736-61.44zM288.512 399.904c8-0.128 16-3.168 22.112-9.28l48-48a31.968 31.968 0 1 0-45.248-45.248l-48 48a31.68 31.68 0 0 0-8.928 20.256L174.816 278.4c-0.512-0.512-0.512-1.024-0.352-1.152L312.64 139.04c0.128-0.128 0.672-0.128 1.248 0.416l184.384 196.992-142.432 135.328-67.328-71.872zM145.024 868.288a1.6 1.6 0 0 1-2.016-1.92l28.992-123.744c0.992-4.16 2.944-7.968 5.312-11.488a31.808 31.808 0 0 0 6.752 10.144l88.288 88.288a35.072 35.072 0 0 1-8 3.552l-119.328 35.168z m598.336 16.672c-0.128 0.128-0.672 0.128-1.248-0.416l-125.6-134.176a31.232 31.232 0 0 0 14.08-7.712l48-48a31.968 31.968 0 1 0-45.248-45.248l-48 48a31.68 31.68 0 0 0-7.296 11.904l-39.904-42.656 142.432-135.328 200.576 214.304c0.48 0.512 0.48 1.024 0.352 1.152l-138.144 138.176z"
              p-id="1397"
            ></path>
          </svg>
          <span style="margin-left: 10px">自定义工作台</span>
          <svg
            v-if="!pagePropData.switchUserCustomizationCommutant"
            :style="{ transform: `rotate(${openUserCustomizationLeftBar ? 180 : 0}deg)` }"
            @click="openUserCustomizationLeftBar = !openUserCustomizationLeftBar"
            t="1659592354438"
            class="fold-svg"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="17129"
            width="24"
            height="24"
          >
            <path
              d="M130.901333 529.493333l149.205334 130.517334a8.533333 8.533333 0 0 0 14.122666-6.4V392.533333a8.533333 8.533333 0 0 0-14.122666-6.4L130.901333 516.608a8.533333 8.533333 0 0 0 0 12.8z"
              p-id="17130"
            ></path>
            <path
              d="M128 213.333333m42.666667 0l682.666666 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666667l-682.666666 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667Z"
              p-id="17131"
            ></path>
            <path
              d="M128 725.333333m42.666667 0l682.666666 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666667l-682.666666 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667Z"
              p-id="17132"
            ></path>
            <path
              d="M384 469.333333m42.666667 0l426.666666 0q42.666667 0 42.666667 42.666667l0 0q0 42.666667-42.666667 42.666667l-426.666666 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666667Z"
              p-id="17133"
            ></path>
          </svg>
        </div>
        <div class="idm_page_user_defined_tip">
          {{
            pagePropData.switchUserCustomizationCommutant
              ? "当前模式支持组件位置对调和组件容器大小调整、移动、删除、添加等操作"
              : "您可以对可调整的卡片组件进行移动、添加、删除等操作"
          }}
        </div>
        <div>
          <idm-a-button
            @click="userDefinedSave"
            :loading="userDefinedSaveLoading"
            type="primary"
            >保 存</idm-a-button
          >
          <idm-a-button @click="userDefinedQuit" style="margin: auto 10px"
            >退出编辑</idm-a-button
          >
          <idm-a-button
            @click="userDefinedReset"
            :loading="userDefinedSaveLoading"
            style="margin-right: 10px"
            >重置</idm-a-button
          >
        </div>
      </div>
    </transition>
    <transition name="idm_page_user_defined_leftbar">
      <div
        v-if="
          pageUserDefinedStatus &&
          openUserCustomizationLeftBar &&
          hiddenCustomizationToolBar
        "
        class="idm_page_user_defined_leftbar"
      >
        <div
          class="idm_page_user_defined_allmodule_item"
          :class="item.hidden !== true ? 'hover-show-remove' : ''"
          v-for="(item, index) in originalUserCustomizationModuleObject.children"
          :key="index"
        >
          <span
            :title="
              (item.props && item.props.basicAttr && item.props.basicAttr.title) ||
              (item.props &&
                item.props.compositeAttr &&
                item.props.compositeAttr.title) ||
              item.asName
            "
          >
            {{
              (item.props && item.props.basicAttr && item.props.basicAttr.title) ||
              (item.props &&
                item.props.compositeAttr &&
                item.props.compositeAttr.title) ||
              item.asName
            }}
          </span>
          <div
            class="idm_page_user_defined_allmodule_item_op"
            :title="item.hidden === true ? '添加组件' : '移除组件'"
          >
            <svg
              t="1659636928260"
              class="user-defined-selected-svg"
              v-if="item.hidden !== true"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9243"
              width="18"
              height="18"
            >
              <path
                d="M944.78369497 156.71660696l38.8044445 32.66674931a25.36238224 25.36238224 0 0 1 3.04348577 35.76095873L486.63761776 818.67478965a76.08714794 76.08714794 0 0 1-107.20679132 9.18118218l-2.40942618-2.10507822-2.28261403-2.20652672L58.64741395 508.44212703a25.36238224 25.36238224 0 0 1-0.07608729-35.86240846l35.81168359-35.93849576a25.36238224 25.36238224 0 0 1 35.88777088-0.05072486l296.56233848 295.6239297 482.21497784-572.42897249a25.36238224 25.36238224 0 0 1 35.73559752-3.0688482z"
                p-id="9244"
              ></path>
            </svg>
            <svg
              t="1659636887235"
              class="user-defined-add-svg"
              @click="addUserDefinedSelect(item)"
              v-if="item.hidden === true"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9088"
              width="18"
              height="18"
            >
              <path
                d="M462.80754569 45.96622222m10.35630616 0l77.6722963 0q10.35630617 0 10.35630616 10.35630617l0 911.35494322q0 10.35630617-10.35630616 10.35630617l-77.6722963 0q-10.35630617 0-10.35630616-10.35630617l0-911.35494322q0-10.35630617 10.35630616-10.35630617Z"
                p-id="9089"
              ></path>
              <path
                d="M66.67883457 462.80754569m10.35630618 0l869.9297185 0q10.35630617 0 10.35630618 10.35630616l0 77.6722963q0 10.35630617-10.35630618 10.35630616l-869.9297185 0q-10.35630617 0-10.35630618-10.35630616l0-77.6722963q0-10.35630617 10.35630618-10.35630616Z"
                p-id="9090"
              ></path>
            </svg>
            <svg
              t="1659629683475"
              class="user-defined-remove-svg"
              @click="removeUserDefinedSelect(item)"
              v-if="item.hidden !== true"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9221"
              width="18"
              height="18"
            >
              <path
                d="M576 512l277.333333 277.333333-64 64-277.333333-277.333333L234.666667 853.333333 170.666667 789.333333l277.333333-277.333333L170.666667 234.666667 234.666667 170.666667l277.333333 277.333333L789.333333 170.666667 853.333333 234.666667 576 512z"
                p-id="9222"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </transition>
    <idm-a-modal
      title="组件选择"
      :visible="pageUserDefinedModalVisible"
      @cancel="pageUserDefinedModalVisible = false"
      :footer="null"
      width="666px"
    >
      <div
        v-if="currentContainerShowModuleName"
        class="idm_page_user_defined_modal_alert"
      >
        当前位置已显示
        <span>{{ currentContainerShowModuleName }}</span>
        组件，您可以选择其他组件交换当前组件显示的位置
      </div>
      <div v-else class="idm_page_user_defined_modal_alert">
        当前位置没有组件，您可以选择一个组件添加到当前位置
      </div>
      <div v-if="customModuleObject" class="idm_page_user_defined_modal_modulelist">
        <template v-for="(item, index) in customModuleObject.children || []">
          <div
            class="idm_page_user_defined_modal_moduleitem"
            :class="{ active: item.packageid == currentContainerShowPackageid }"
            v-if="
              (!currentContainerShowPackageid && item.containerIndex >= 999999999) ||
              currentContainerShowPackageid
            "
            :key="index"
          >
            <div
              :title="
                (item.props && item.props.basicAttr && item.props.basicAttr.title) ||
                (item.props &&
                  item.props.compositeAttr &&
                  item.props.compositeAttr.title) ||
                item.asName
              "
            >
              <label>{{
                (item.props && item.props.basicAttr && item.props.basicAttr.title) ||
                (item.props &&
                  item.props.compositeAttr &&
                  item.props.compositeAttr.title) ||
                item.asName
              }}</label>
              <span v-if="item.containerIndex < 999999999"
                >已显示在序号 {{ item.containerIndex }} 容器中
              </span>
            </div>
            <div>
              <div
                v-if="item.packageid == currentContainerShowPackageid"
                class="user-defined-modal-selected"
              >
                <svg
                  t="1659636928260"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9243"
                  width="18"
                  height="18"
                >
                  <path
                    d="M944.78369497 156.71660696l38.8044445 32.66674931a25.36238224 25.36238224 0 0 1 3.04348577 35.76095873L486.63761776 818.67478965a76.08714794 76.08714794 0 0 1-107.20679132 9.18118218l-2.40942618-2.10507822-2.28261403-2.20652672L58.64741395 508.44212703a25.36238224 25.36238224 0 0 1-0.07608729-35.86240846l35.81168359-35.93849576a25.36238224 25.36238224 0 0 1 35.88777088-0.05072486l296.56233848 295.6239297 482.21497784-572.42897249a25.36238224 25.36238224 0 0 1 35.73559752-3.0688482z"
                    p-id="9244"
                  ></path>
                </svg>
                已选
              </div>
              <div
                @click="userDefinedModuleReplace(item, 'changeseats')"
                v-else-if="item.containerIndex < 999999999"
                class="user-defined-modal-changeseats"
              >
                <svg
                  t="1660186463623"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7012"
                  width="18"
                  height="18"
                >
                  <path
                    d="M629.419 104.311c113.459 11.333 204.663 79.736 224.05 196.882h-65.672l106.087 157.832L999.97 301.193h-73.182c-19.524-157.833-138.99-260.37-289.86-274.979-20.89-1.638-40.277 16.248-40.277 39.049 1.365 19.524 14.745 37.41 32.768 39.048z m-164.25-79.735H96.256c-20.89 0-37.274 17.886-37.274 40.687V416.7c0 22.8 16.384 40.687 37.274 40.687h368.913c20.89 0 37.274-17.886 37.274-40.687V65.263c0-22.801-16.384-40.687-37.274-40.687zM429.261 379.29H132.164V102.673h297.233l-0.136 276.617z m-35.908 540.125c-126.976-11.332-224.052-95.982-228.557-235.93h70.178L129.16 525.79 23.074 683.486h70.178c2.867 180.633 129.843 297.78 292.728 314.027 20.89 1.638 40.277-16.248 40.277-39.049 0.41-19.388-13.653-36.045-32.904-39.049z m534.8-353.075H559.242c-21.027 0-37.274 18.023-37.274 40.687v353.075c0 22.665 16.384 40.55 37.274 40.55h368.913c20.89 0 37.273-17.885 37.273-40.55V607.027c0-22.664-17.886-40.687-37.273-40.687z m-35.908 354.714H595.012V646.076h297.233v274.978z m0 0"
                    p-id="7013"
                  ></path>
                </svg>
                换位
              </div>
              <div
                @click="userDefinedModuleReplace(item, 'replace')"
                v-else-if="currentContainerShowPackageid"
                class="user-defined-modal-replace"
              >
                <svg
                  t="1660186765079"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7166"
                  width="18"
                  height="18"
                >
                  <path
                    d="M911.14666667 610.98666667H112.85333333c-23.57333333 0-42.66666667 19.09333333-42.66666666 42.66666666 0 8.96 2.77333333 17.28 7.46666666 24.10666667 2.02666667 4.8 5.12 9.28 8.96 13.22666667L274.66666667 878.93333333c8.32 8.32 19.2 12.48 30.18666666 12.48s21.86666667-4.16 30.18666667-12.48c16.64-16.64 16.64-43.62666667 0-60.37333333L212.58666667 696.32h698.45333333c23.57333333 0 42.66666667-19.09333333 42.66666667-42.66666667s-18.98666667-42.66666667-42.56-42.66666666zM112.85333333 413.01333333h798.29333334c23.57333333 0 42.66666667-19.09333333 42.66666666-42.66666666 0-8.96-2.77333333-17.28-7.46666666-24.10666667-1.49333333-3.52-3.62666667-6.93333333-6.18666667-10.13333333L786.34666667 148.16c-14.93333333-18.24-41.81333333-20.90666667-60.05333334-5.97333333-18.24 14.93333333-20.90666667 41.81333333-5.97333333 60.05333333l102.72 125.44H112.85333333c-23.57333333 0-42.66666667 19.09333333-42.66666666 42.66666667s19.09333333 42.66666667 42.66666666 42.66666666z"
                    p-id="7167"
                  ></path>
                </svg>
                替换
              </div>
              <div
                @click="userDefinedModuleReplace(item, 'add')"
                v-else-if="!currentContainerShowPackageid"
                class="user-defined-modal-replace"
              >
                <svg
                  t="1691718391348"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="20565"
                  width="18"
                  height="18"
                >
                  <path
                    d="M899.657143 442.514286h-329.142857v-329.142857c0-29.257143-25.6-54.857143-54.857143-54.857143s-54.857143 25.6-54.857143 54.857143v329.142857h-329.142857c-29.257143 0-54.857143 25.6-54.857143 54.857143s25.6 54.857143 54.857143 54.857142h329.142857v329.142858c0 29.257143 25.6 54.857143 54.857143 54.857142s54.857143-25.6 54.857143-54.857142v-329.142858h329.142857c29.257143 0 54.857143-25.6 54.857143-54.857142s-21.942857-54.857143-54.857143-54.857143z"
                  ></path>
                </svg>
                添加
              </div>
            </div>
          </div>
        </template>
        <div v-if="isEmptyCustomModuleObject">没有可选择的组件</div>
      </div>
    </idm-a-modal>
  </div>
</template>

<script>
//流程plumb连线
import jsplumb from "jsplumb";
//jsplumb配置信息
import { jsplumbConfig } from "../plugins/config/jsplumb";

import mixin from "./mixin";
export default {
  mixins: [mixin],
  name: "Page",
  components: { jsplumb },
  data() {
    return {
      containerStyleObject: {
        width: null,
        height: null,
        "min-height": null,
      },
      contentStyleObject: {
        width: null,
        height: null,
        overflow: null,
        "transform-origin": null,
        transform: null,
      },
      //当前主题是否已经设置过了，true代表设置过了，默认值不设置了
      themeSetObject: "",
      //当前页面的数据
      PageSettingData: {},
      dialogVisibleStatus: false,
      //是否正在隐藏中
      dialogIsHideing: false,
      //窗口的对象
      dialogObjectList: [],
      //控制中心窗口是否显示
      drawerVisible: false,
      //页面属性
      pagePropData: {},
      //页面是否已经在用户自定义状态
      pageUserDefinedStatus: false,
      //保存动画
      userDefinedSaveLoading: false,
      //是否打开组件列表
      openUserCustomizationLeftBar: false,
      //是否隐藏定制化工具栏
      hiddenCustomizationToolBar: false,
      //用户定制化的对象
      originalUserCustomizationModuleObject: { children: [] },
      //用户定制化组件选择对象
      pageUserDefinedModalVisible: false,
      //当前容器显示的packageid
      currentContainerShowPackageid: "",
      //当前容器显示的组件名称
      currentContainerShowModuleName: "",
      //当前容器显示的组件对象
      currentContainerShowModuleObject: {},
      //当前要添加组件的容器索引
      currentContainerShowModuleContainerIndex: -1,
      customModuleObject: null,
      //页面接口返回结果对象
      pageInterfaceResultObject: {},
      /*
        动态渲染组件的等待消费对象，需要在各个组件回调中进行消费掉，消费完删除即可
        packageid 循环容器的id,
        allModulePackageId 循环容器动态渲染的所有组件的id,
        idmContainerId 动态渲染的循环容器的containerIndex,
        itemData 循环容器当前组的数据对象
        sendMessageKey 消息key
      */
      dynamicWaitExpendObject: [],
    };
  },
  props: {
    //页面ID
    pageid: {
      type: String,
    },
    //路由ID，为空代表是主页面
    routerId: {
      type: String,
    },
    //是否预览页面
    devpreview: {
      type: Boolean,
    },
    //是否主页面
    mainPage: {
      type: Boolean,
    },
    index: {
      type: Number,
    },
    styleObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    let that = this;
    if (this.devpreview) {
      //取缓存数据
      this.PageSettingData = JSON.parse(window.localStorage["devpreview"]);
      console.log("当前预览的缓存数据", this.PageSettingData);
      this.setCachePageData(this.PageSettingData);
      this.loadPageElement();
    } else {
      if (IDM.router.pageDataCachePool.get(this.pageid)) {
        this.PageSettingData = _.cloneDeep(IDM.router.pageDataCachePool.get(this.pageid));
        console.log(
          "从缓存池中获取到页面配置数据（同pageid情况下）",
          this.PageSettingData
        );
        this.loadPageElement();
      } else {
        this.$previewApi
          .fetchPageSettingDataForVersion({
            pageid: this.pageid,
            version: "", //当前的版本，没有则必须要返回最新的，有版本要返回对应的版本结果
            urlData: this.commonParam().urlData,
          })
          .then((res) => {
            //获取页面配置数据返回数据结果
            this.PageSettingData = res.data.data;
            this.setCachePageData(this.PageSettingData);
            console.log("从数据接口中获取页面配置数据返回数据结果", this.PageSettingData);
            this.loadPageElement();
          })
          .catch(function (error) {
            IDM.message.error("页面配置信息加载失败！message：" + error.message);
          });
      }
    }
  },
  computed: {
    isEmptyCustomModuleObject: function () {
      return (
        this.customModuleObject?.children?.filter(
          (item) =>
            (!this.currentContainerShowPackageid && item.containerIndex >= 999999999) ||
            this.currentContainerShowPackageid
        ).length === 0
      );
    },
  },
  methods: {
    pageResize(clientWH) {
      let basicAttr = this.PageSettingData.page.layout.props.basicAttr;
      if (basicAttr && basicAttr.openPageWH) {
        if (!clientWH) {
          clientWH = IDM.getClientWH();
        }
        this.containerStyleObject.width = clientWH.width + "px";
        this.containerStyleObject.height = clientWH.height + "px";
        this.containerStyleObject["min-height"] = "initial";
        let pageWH = basicAttr.pageWH || "1920,1080";
        pageWH = pageWH.split(",");
        let pageWidth = pageWH[0],
          pageHeight = pageWH[1];
        this.contentStyleObject["width"] = pageWidth + "px";
        this.contentStyleObject["height"] = pageHeight + "px";
        this.contentStyleObject["overflow"] = "hidden";
        let pageWHType = basicAttr.pageWHType || "X";
        let scaleX = 1,
          scaleY = 1,
          scaleRatio = 1;
        let bodyCss = {};
        switch (pageWHType) {
          case "X":
            scaleY = scaleX = clientWH.width / pageWidth;
            bodyCss["overflow-y"] = "auto";
            bodyCss["overflow-x"] = "hidden";
            break;
          case "Y":
            scaleY = scaleX = clientWH.height / pageHeight;
            bodyCss["overflow-y"] = "hidden";
            bodyCss["overflow-x"] = "auto";
            break;
          case "XY":
            scaleX = clientWH.width / pageWidth;
            scaleY = clientWH.height / pageHeight;
            bodyCss["overflow-y"] = "hidden";
            bodyCss["overflow-x"] = "hidden";
            break;
        }
        //$("body").css(bodyCss);
        this.$nextTick(() => {
          $("body").css(bodyCss);
        });
        this.contentStyleObject["transform"] = "scale(" + scaleX + ", " + scaleY + ")";
        this.contentStyleObject["transform-origin"] = "0 0";
      }
    },
    setCachePageData(PageSettingData) {
      let that = this;
      try {
        this.propsCompletion(
          PageSettingData.page.layout,
          PageSettingData.page.componentsMap
        );
      } catch (e) {}
      IDM.router.pageDataCachePool.put(that.pageid, _.cloneDeep(PageSettingData));
    },
    /**
     * 补全属性数据到树结构中
     * @param {*} foreachList
     * @param {*} componentsMap
     */
    propsCompletion(foreachList, componentsMap) {
      if (!(foreachList instanceof Array)) {
        foreachList = [foreachList];
      }
      for (let i = 0; i < foreachList.length; i++) {
        let module = foreachList[i];
        if (module.packageid) {
          let componentFilter = componentsMap.filter(
            (item) => item.packageid == module.packageid
          );
          if (componentFilter && componentFilter.length > 0) {
            module.props = componentFilter[0].props;
            if (componentFilter[0].svgData) {
              module.svgData = componentFilter[0].svgData;
            }
          }
        }
        if (module.children && module.children.length > 0) {
          this.propsCompletion(module.children, componentsMap);
        }
      }
    },
    async loadPageElement() {
      let react = false;
      //查找props覆盖树结构中的
      for (
        let index = 0;
        index < this.PageSettingData.page.componentsMap.length;
        index++
      ) {
        const item = this.PageSettingData.page.componentsMap[index];
        if (item.comLangue && item.comLangue.toLocaleLowerCase() == "react") {
          react = true;
        }
      }
      //加载react或者其他技术栈的lib
      await this.initReactOrOtherLib(react);
      //追加js脚本
      if (
        this.PageSettingData.page.actions &&
        this.PageSettingData.page.actions.compiled
      ) {
        var pageScriptDom = $(
          '<script type="text/javascript" id="' + this.pageid + '"/>'
        );

        $("body").append(
          pageScriptDom.html(`
       (function(){
        var exports={};
        ${this.PageSettingData.page.actions.compiled}
        var functionList = Object.keys(exports);
        for(var i=0;i<functionList.length;i++){
          window[functionList[i]] = exports[functionList[i]];
        }
       })();
       `)
        );
      }
      this.initModulePropCustomBuildCode(this.PageSettingData.page.layout);
      //把map中的数据更新下
      this.PageSettingData.page.componentsMap.forEach((item) => {
        item.env = "production";
        //追加路由ID，页面ID
        item.routerId = this.routerId;
        item.pageid = this.pageid;
        if (item.comId == "0") {
          item.idmBroadcastMessage = this.idmBroadcastMessage;
        }
      });
      //把页面数据注册到消息桥接器中（改造成支持子页面）
      this.IDM.broadcast.registerModule(this.PageSettingData, this.pageid, this.routerId);
      this.setCurrentPageTitle();
      //先加载应用信息
      await this.initAppAndUserInfo(this.PageSettingData.page.layout.props);
      //判断是否需要加载连线
      let propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      if (propData.openJsPlumb === true) {
        this.initJsPlumb();
      }
      this.requestPageCommonInterfaceDataBefore(() => {
        //加载完成事件
        this.setCurrentPageTitle(true);
        if (this.mainPage) {
          this.$emit("mainPageSettingHandle", this.PageSettingData);
        }
        //加载组件样式，样式内部支持使用页面接口返回的数据
        this.initModulePropCustomBuildStyle(this.PageSettingData.page.layout);
        //组件开始加载之前执行
        this.beforeLoadingFunction();
        //基本属性渲染(页面定制大小属性)
        this.pageResize();
        //页面的属性渲染
        this.pageAttrPropHandle(this.PageSettingData.page.layout.props);
        //执行组件加载
        this.$nextTick(function () {
          this.initModuleTreeToPage(null, true, this.PageSettingData.page.layout);
        });
      });
    },
    /**
     * 组件通信：接收消息的方法
     * @param {
     *  type:"发送消息的时候定义的类型，这里可以自己用来要具体做什么，统一规定的type：linkageResult（组件联动传结果值）、linkageDemand（组件联动传需求值）、linkageReload（联动组件重新加载）
     * 、linkageOpenDialog（打开弹窗）、linkageCloseDialog（关闭弹窗）、linkageShowModule（显示组件）、linkageHideModule（隐藏组件）、linkageResetDefaultValue（重置默认值）"
     *  message:{发送的时候传输的消息对象数据}
     *  messageKey:"消息数据的key值，代表数据类型是什么，常用于表单交互上，比如通过这个key判断是什么数据"
     *  isAcross:如果为true则代表发送来源是其他页面的组件，默认为false
     * } object
     */
    idmBroadcastMessage(object) {
      if (object.type === "pageCommonInterface") {
        return;
      }
      //一定要注释，因为收到消息可能是会很频繁的，这里可以选择防抖，但实际效果可能不太好（因为改变窗口要停止了元素才会变化，所以体验效果不好，但是节约了性能）
      console.log("页面组件收到消息", object, this.PageSettingData);
      var interfaceList =
        (this.PageSettingData.page.layout.props.compositeAttr
          ? this.PageSettingData.page.layout.props.compositeAttr.interfaceList
          : []) || [];
      if (interfaceList.length == 0) {
        // callback && callback();
        return;
      }
      this.orderlyRequestInterface(
        interfaceList,
        0,
        this.InterfaceParam(),
        function () {
          console.log("页面接口已重新请求完成");
        },
        object
      );
    },
    /**
     * 会话保持功能
     * 此处专门为应用程序登录信息为session准备的（在需要登录信息永久保持的情况下才建议开启此功能）
     * 处理流程：
     * 1、用户密码登录或单点登录的时候同时后端通过jwt（用户信息+密钥）生成登录令牌并存储在前端（url参数、cookie、localStorage）
     * 2、IDM在请求获取用户信息接口后发现session掉了则会通过后端提供通过jwt重新进行登录的接口去登录，一旦发现登录成功则会二次去请求获取用户信息接口
     * 3、如果jwt登录也失效了则会执行原来的跳转登录地址
     */
    async silentReLogin(propData, isreload) {
      if (propData && propData.openSessionKeep && propData.silentReLoginUrl) {
        let relogin = false,
          cacheKeyName = IDM.setting.sessionKeep.cacheKeyName,
          cacheKeyValue = "";
        console.log("当前页面cookie信息", document.cookie);
        console.log("获取到的cookie信息：" + cacheKeyName, IDM.getCookie(cacheKeyName));
        if (window.localStorage[cacheKeyName]) {
          cacheKeyValue = window.localStorage[cacheKeyName];
        } else if (IDM.getCookie(cacheKeyName)) {
          cacheKeyValue = IDM.getCookie(cacheKeyName);
        } else if (IDM.url.queryObject()[cacheKeyName]) {
          cacheKeyValue = IDM.url.queryObject()[cacheKeyName];
        }
        await IDM.http
          .post(propData.silentReLoginUrl, {
            [cacheKeyName]: cacheKeyValue,
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code == "200") {
              relogin = true;
            }
          })
          .catch(function (error) {});
        if (relogin) {
          await this.fetchUserInfo(propData, false, true, true);
        }
      }
    },
    /**
     * 获取用户信息接口
     * propData:页面属性
     * sessionKeep：是否检查使用会话保持
     */
    async fetchUserInfo(propData, sessionKeep, isreload, resetUserInfo) {
      let loginStatus = true,
        that = this;
      await this.$previewApi
        .fetchUserInfo(propData.userInfoUrl, {
          pageid: this.pageid,
          ...this.commonParam(),
        })
        .then((res) => {
          let resData = res.data;
          if (resData.code == "200" && resData.data) {
            resData = resData.data;
          } else if (resData.code != "200") {
            loginStatus = false;
          }
          //只有是主页面才会设置用户信息
          (that.mainPage || resetUserInfo) && IDM.user.setCurrentUserInfo(resData);
          //发送刷新数据
          (that.mainPage || resetUserInfo) &&
            loginStatus &&
            isreload &&
            IDM.broadcast.send(
              {
                type: "linkageReload",
                rangeModule: "",
                message: new Date().getTime(),
              },
              that.routerId
            );
        })
        .catch(function (error) {
          loginStatus = false;
        });
      if (sessionKeep && !loginStatus) {
        await this.silentReLogin(propData, isreload);
      }
    },
    /**
     * 同步方式加载应用信息和用户信息
     * 并且需要判断一下是否已经设置了登录判断，如果设置了则需要确定用户ID是否为空，为空则跳转到设置好的登录地址
     */
    async initAppAndUserInfo(propDataObject) {
      let that = this;
      let propData = propDataObject.compositeAttr;
      if (
        propData.openFetchApplicationInfo &&
        propData.applicationInfoUrl &&
        this.mainPage
      ) {
        await this.$previewApi
          .fetchApplicationInfo(propData.applicationInfoUrl, {
            pageid: this.pageid,
            ...this.commonParam(),
          })
          .then((res) => {
            let resData = res.data;
            if (resData.code == "200" && resData.data) {
              resData = resData.data;
            }
            IDM.app.setAppInfo(resData);
          })
          .catch(function (error) {});
      }
      //只会保留主页面的用户信息，如果子页面开启了只有会话丢失了且再次使用重登录功能才会去把当前用户信息重新设置
      if (propData.openFetchUserInfo && propData.userInfoUrl) {
        await this.fetchUserInfo(propData, true);
      }
      let switchUserInfoFiledValue = "";
      if (propData.switchUserInfo && propData.switchUserInfoFiledName) {
        let filedExp = propData.switchUserInfoFiledName,
          echoDataName = "userObject";
        var dataObject = { IDM: window.IDM };
        dataObject[echoDataName] = IDM.user.getCurrentUserInfo();

        if (filedExp) {
          filedExp = echoDataName + (filedExp.startsWiths("[") ? "" : ".") + filedExp;
          switchUserInfoFiledValue = window.IDM.express.replace.call(
            this,
            "@[" + filedExp + "]",
            dataObject
          );
        }
        IDM.user.setUserLoginInfo(true, propData.loginPageUrl);
      } else if (propData.switchUserInfo) {
        switchUserInfoFiledValue =
          IDM.user.getCurrentUserInfo() && IDM.user.getCurrentUserInfo().data
            ? IDM.user.getCurrentUserInfo().data.userid
            : "";
        IDM.user.setUserLoginInfo(true, propData.loginPageUrl);
      }
      //判断是否需要登录(这里暂时写死data.userid)
      if (propData.switchUserInfo && !switchUserInfoFiledValue) {
        if (propData.loginPageUrl) {
          //跳转
          window.location.href = IDM.url.getWebPath(propData.loginPageUrl);
        } else {
          window.location.href = "";
        }
      }
      //判断是否开启应用和个性化设置（每个页面都需要的）
      if (
        propData.openFetchUserInfo &&
        propData.switchUserCustomization &&
        propData.userCustomizationFetchUrl
      ) {
        let customContainerModuleId =
          propData.userCustomizationModuleContainer &&
          propData.userCustomizationModuleContainer.length > 0
            ? propData.userCustomizationModuleContainer[0].moduleId
            : "";
        //如果为空则默认为页面ID
        if (!customContainerModuleId) {
          customContainerModuleId = that.PageSettingData.id;
        }
        const originalUserCustomizationModuleObject = _.cloneDeep(
          that.getModuleTree(that.PageSettingData.page.layout, customContainerModuleId)
        );
        let newCustomModuleList = [];
        originalUserCustomizationModuleObject &&
          originalUserCustomizationModuleObject.children?.forEach((customItem) => {
            if (IDM.page.checkComponentHasAuthority(customItem)) {
              newCustomModuleList.push(customItem);
            }
          });

        that.originalUserCustomizationModuleObject = { children: newCustomModuleList };
        //获取定制化后的结果
        await this.$previewApi
          .fetchUserCustomizationInfo(propData.userCustomizationFetchUrl, {
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
            urlData: JSON.stringify(this.commonParam()),
          })
          .then((res) => {
            if (res && res.data && res.data.data && res.data.data.customData) {
              //定制结果不为空，用用户定制的结果去跟页面结构递归循环去比对然后对他们修改排序
              let customData =
                res.data.data.customData instanceof Object
                  ? res.data.data.customData
                  : JSON.parse(res.data.data.customData);
              //获取排序后的数组
              const userCustomModuleArray = customData.children;
              if (
                !userCustomModuleArray ||
                (userCustomModuleArray && userCustomModuleArray.length == 0)
              ) {
                return;
              }
              //比对找到组件（等于customData.packageid）下的所有数组，然后分别对他们进行数组调整
              let reSortModule = that.getModuleTree(
                that.PageSettingData.page.layout,
                customData.packageid
              );
              if (reSortModule && reSortModule.children) {
                //重新排序
                let newChildren = [],
                  allUserCustomModuleIds = [];
                userCustomModuleArray.forEach((item, index) => {
                  allUserCustomModuleIds.push(item.packageid);
                  //用户没有开启组件互换才去赋值
                  if (!propData.switchUserCustomizationCommutant) {
                    let lsmodule = that.getModuleTree(
                      that.originalUserCustomizationModuleObject,
                      item.packageid
                    );
                    lsmodule ? (lsmodule.hidden = item.hidden) : null;
                  }
                  for (let index = 0; index < reSortModule.children.length; index++) {
                    const element = reSortModule.children[index];
                    if (item.packageid == element.packageid && item.hidden !== true) {
                      element.containerIndex = item.containerIndex;
                      element.relationType = item.relationType;
                      element.relationId = item.relationId;
                      newChildren.push(element);
                      break;
                    }
                  }
                });
                //没有在个性化定制里面的组件
                if (propData.switchUserCustomizationCommutant) {
                  for (let index = 0; index < reSortModule.children.length; index++) {
                    const element = reSortModule.children[index];
                    if (allUserCustomModuleIds.indexOf(element.packageid) == -1) {
                      newChildren.push(element);
                    }
                  }
                } else if (
                  that.originalUserCustomizationModuleObject &&
                  that.originalUserCustomizationModuleObject.children
                ) {
                  for (
                    let index = 0;
                    index < that.originalUserCustomizationModuleObject.children.length;
                    index++
                  ) {
                    const element =
                      that.originalUserCustomizationModuleObject.children[index];
                    if (allUserCustomModuleIds.indexOf(element.packageid) == -1) {
                      element.hidden = true;
                    }
                  }
                }
                reSortModule.children = newChildren;
              }
            }
          })
          .catch(function (error) {});
      }

      //应用主题：接口的方式    主页面才会请求的
      if (
        that.mainPage &&
        propData.openIdmTheme &&
        propData.themeFetchType == "customInterface" &&
        propData.themeInterfaceUrl
      ) {
        await this.$previewApi
          .fetchThemeInfo(propData.themeInterfaceUrl, {
            pageid: this.pageid,
            ...this.commonParam(),
          })
          .then((res) => {
            that.themeInterfaceHandle(res.data, "resultData");
          })
          .catch(function (error) {});
      } else if (
        that.mainPage &&
        propData.openIdmTheme &&
        propData.themeFetchType == "customFunction" &&
        propData.themeCustomFunction &&
        propData.themeCustomFunction.length > 0
      ) {
        //自定义处理函数
        let switchThemeValue = "";
        propData.themeCustomFunction.forEach((sitem) => {
          try {
            switchThemeValue =
              window[sitem.name] &&
              window[sitem.name].call(this, {
                ...this.commonParam(),
                customParam: sitem.param,
                _this: that,
              });
          } catch (error) {}
        });
        IDM.theme.setCurrentThemeInfo(switchThemeValue);
        that.themeSetObject = switchThemeValue;
      }
    },
    /**
     * 用户自定义的时候移动组件的索引位置事件
     * @param {routerId:"路由ID",pageid:"页面ID",moveIndex:"要移动组件的索引位置",targetIndex:"移动到的索引位置"} ctx
     */
    componentMoveIndexHandle(ctx) {
      let propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      const customContainerModuleId =
        propData.userCustomizationModuleContainer &&
        propData.userCustomizationModuleContainer.length > 0
          ? propData.userCustomizationModuleContainer[0].moduleId
          : "";
      if (!customContainerModuleId || !this.pageUserDefinedStatus) {
        return;
      }
      //对容器组件查找
      let customModuleObject = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        customContainerModuleId
      );
      if (!customModuleObject) {
        return false;
      }
      //查找要移动的组件
      customModuleObject &&
        customModuleObject.children?.forEach((item) => {
          if (item.containerIndex == ctx.moveIndex) {
            item.containerIndex = ctx.targetIndex;
            $(
              document
                .querySelector(`#router_page_${this.routerId}`)
                .querySelector(`#${item.packageid}`)
            ).remove();
            item.relationType = "inner_" + item.containerIndex;
          }
        });
    },
    /**
     * 页面用户自定义状态切换触发事件
     * status：true 进入编辑状态   false  退出编辑状态
     * save: true 且 status的参数为 false 的时候则是需要保存状态,其他情况则是不执行保存状态
     */
    pageUserDefinedStatusChangeHandle(status = true, save = false) {
      let that = this;
      this.pageUserDefinedStatus = status;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      this.hiddenCustomizationToolBar = propData.hiddenCustomizationToolBar !== true;
      let eleDiffPos = {},
        userDefinedDomList,
        userDefinedContainerDomList,
        moveDomBox,
        switchUserCustomizationCommutant = propData.switchUserCustomizationCommutant;
      // this.openUserCustomizationLeftBar = !switchUserCustomizationCommutant;
      if (
        propData.customizationToolBarToogleEvent &&
        propData.customizationToolBarToogleEvent.length > 0
      ) {
        let resultBack = this.commonCustomEventFunHandle(
          propData,
          "customizationToolBarToogleEvent",
          {
            status,
            save,
            pageData: this.PageSettingData.page,
            routerId: that.routerId,
          }
        );
        if (resultBack === false) {
          return;
        }
      }
      //首先找出要自定义的容器组件
      /**
       * 组件范围选择返回的格式：
       * [
       *  {
       *  moduleId:packageid,
       *  moduleName:asName
       *  }
       * ]
       */
      const customContainerModuleId =
        propData.userCustomizationModuleContainer &&
        propData.userCustomizationModuleContainer.length > 0
          ? propData.userCustomizationModuleContainer[0].moduleId
          : "";
      if (!customContainerModuleId) {
        IDM.message.info("没有可以自定义的容器组件！");
        return;
      }
      //对容器组件查找
      let customModuleObject = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        customContainerModuleId
      );
      if (!customModuleObject) {
        return false;
      }
      let newCustomModuleObjectList = [];
      customModuleObject &&
        customModuleObject.children?.forEach((item) => {
          if (IDM.page.checkComponentHasAuthority(item)) {
            newCustomModuleObjectList.push(item);
          }
        });

      this.customModuleObject = {
        children: newCustomModuleObjectList,
        id: customModuleObject.id,
        packageid: customModuleObject.packageid,
      };
      const customModuleRectInfo = document
        .querySelector(`#router_page_${that.routerId}`)
        .querySelector(`#${customModuleObject.packageid}`)
        .getBoundingClientRect();

      let currentMoveDom, placeholderDom, hoverContainerDom;
      //minYDom：最接近的dom，locationStr：居于上面还是下面
      let minYDom,
        locationStr = "";
      //拖拽的移动
      !this.moduleMoveEvent
        ? (this.moduleMoveEvent = function (e) {
            e.stopPropagation();
            e.preventDefault();
            const packageid = e.target.dataset.packageid;
            //移动的时候要改变 idm_module_user_defined_movebox 的 left、top
            //用鼠标的坐标减去元素相对于鼠标的差值
            var position = {};
            position.x = e.clientX - eleDiffPos.x;
            position.y = e.clientY - eleDiffPos.y;
            moveDomBox.style.left = position.x + "px";
            moveDomBox.style.top = position.y + "px";
            //计算横向中心点坐标
            const moveDomCenterX =
                position.x + moveDomBox.getBoundingClientRect().width / 2,
              moveDomCenterY = position.y + moveDomBox.getBoundingClientRect().height / 2,
              moveDomLeftX = position.x,
              moveDomRightX = position.x + moveDomBox.getBoundingClientRect().width,
              moveDomTopY = position.y,
              moveDomBottomY = position.y + moveDomBox.getBoundingClientRect().height;
            let isCustomModuleDomOut = false;
            if (
              customModuleRectInfo.x > moveDomRightX ||
              customModuleRectInfo.x + customModuleRectInfo.width < moveDomLeftX ||
              customModuleRectInfo.y > moveDomBottomY ||
              customModuleRectInfo.y + customModuleRectInfo.height < moveDomTopY
            ) {
              isCustomModuleDomOut = true;
            }
            //对可调整的（class=idm_module_user_defined）要进行监听是否触发到元素上了，
            //有两种形式，同一容器下直接排序方式，非同一容器下直接换位或者换位插入（要取页面配置）
            //idm_module_user_defined_placeholderbox 即将要插入的位置
            //当拖拽的元素坐标最大Y轴大于当前元素的Y轴不超过10px则触发换位或排序
            //crossYDomList:Y轴有交叉的
            //topMinDom:X中心点最近、距离moveTop最小的（Y轴无交叉的）
            //bottomMinDom:X中心点最近、距离moveBottom最小的（Y轴无交叉的）
            //centerMinDomList:包含了X中心点的集合
            let crossYDomList = [],
              coverXDomList = [],
              centerCrossXDomList = [];
            userDefinedDomList &&
              userDefinedDomList.forEach((userDefinedDomItem) => {
                //先得出符合Y轴的item
                const itemRectInfo = userDefinedDomItem.parentElement.getBoundingClientRect();
                // console.log("🚀 ~ file: Page.vue ~ line 413 ~ moveEvent ~ itemRectInfo", itemRectInfo)
                const itemTopY = itemRectInfo.y,
                  itemBottomY = itemRectInfo.y + itemRectInfo.height;
                if (
                  (itemTopY <= moveDomTopY && moveDomTopY <= itemBottomY) ||
                  (itemBottomY >= moveDomBottomY && itemTopY <= moveDomBottomY)
                ) {
                  //代表顶部或底部都在当前组件范围内
                  crossYDomList.push(userDefinedDomItem.parentElement);
                }
                //顶部和底部覆盖了小组件的情况(有交叉的情况)
                if (
                  itemTopY > moveDomTopY &&
                  itemBottomY < moveDomTopY &&
                  ((itemRectInfo.x < moveDomLeftX &&
                    itemRectInfo.x + itemRectInfo.width > moveDomLeftX) ||
                    (itemRectInfo.x + itemRectInfo.width < moveDomRightX &&
                      itemRectInfo.x + itemRectInfo.width > moveDomLeftX) ||
                    (moveDomLeftX < itemRectInfo.x &&
                      itemRectInfo.x + itemRectInfo.width > moveDomLeftX &&
                      itemRectInfo.x < moveDomRightX))
                ) {
                  coverXDomList.push(userDefinedDomItem.parentElement);
                }
                if (
                  moveDomCenterX > itemRectInfo.x &&
                  moveDomCenterX < itemRectInfo.x + itemRectInfo.width
                ) {
                  centerCrossXDomList.push(userDefinedDomItem.parentElement);
                }
              });
            // console.log("🚀 ~ file: Page.vue ~ line 420 ~ moveEvent ~ userDefinedDomList", userDefinedDomList)
            // console.log("🚀 ~ file: Page.vue ~ line 410 ~ moveEvent ~ crossYDomList", crossYDomList)
            //过滤完中心点X的dom后
            let filtrXcrossYDomList = [];
            if (crossYDomList.length > 0) {
              //在Y轴有交叉的取出离中心点最近的
              crossYDomList.forEach((userDefinedDomItem) => {
                const itemRectInfo = userDefinedDomItem.getBoundingClientRect();
                if (
                  moveDomCenterX > itemRectInfo.x &&
                  moveDomCenterX < itemRectInfo.x + itemRectInfo.width
                ) {
                  filtrXcrossYDomList.push(userDefinedDomItem);
                }
              });
            }
            //排出取出最小的距离
            let minYNumber = 999999999;
            if (filtrXcrossYDomList.length > 0) {
              //此处只有交叉的情况
              filtrXcrossYDomList.forEach((userDefinedDomItem) => {
                const itemRectInfo = userDefinedDomItem.getBoundingClientRect();
                const itemTopY = itemRectInfo.y,
                  itemBottomY = itemRectInfo.y + itemRectInfo.height;
                if (moveDomTopY - itemTopY < minYNumber) {
                  minYDom = userDefinedDomItem;
                  minYNumber = moveDomTopY - itemTopY;
                  //当前元素上面
                  locationStr = "top";
                }
                if (itemBottomY - moveDomBottomY < minYNumber) {
                  minYDom = userDefinedDomItem;
                  minYNumber = itemBottomY - moveDomBottomY;
                  //当前元素下面
                  locationStr = "bottom";
                }
              });
            } else if (coverXDomList.length > 0) {
              //此处只有Y轴被完全覆盖的
              coverXDomList.forEach((userDefinedDomItem) => {
                const itemRectInfo = userDefinedDomItem.getBoundingClientRect();
                //这里要找出Y轴的中心点离哪个最近
                if (
                  moveDomCenterY > itemRectInfo.y + itemRectInfo.height &&
                  moveDomCenterY - itemRectInfo.y - itemRectInfo.height < minYNumber
                ) {
                  minYDom = userDefinedDomItem;
                  minYNumber = moveDomTopY - itemRectInfo.y - itemRectInfo.height;
                  //当前元素下面
                  locationStr = "bottom";
                }
                if (
                  moveDomCenterY < itemRectInfo.y &&
                  itemRectInfo.y - moveDomCenterY < minYNumber
                ) {
                  minYDom = userDefinedDomItem;
                  minYNumber = itemRectInfo.y - moveDomBottomY;
                  //当前元素上面
                  locationStr = "top";
                }
              });
              if (!minYDom) {
                //上述结果如果没有，那就是中心点在里面
                coverXDomList.forEach((userDefinedDomItem) => {
                  const itemRectInfo = userDefinedDomItem.getBoundingClientRect();
                  if (
                    moveDomCenterY <= itemRectInfo.y + itemRectInfo.height &&
                    moveDomCenterY >= itemRectInfo.y
                  ) {
                    //在中心，取出离X轴中心最近的
                    if (
                      Math.abs(
                        moveDomCenterX - (itemRectInfo.x + itemRectInfo.width / 2)
                      ) < minYNumber
                    ) {
                      minYDom = userDefinedDomItem;
                      minYNumber = Math.abs(
                        moveDomCenterX - (itemRectInfo.x + itemRectInfo.width / 2)
                      );
                    }
                    //当前元素下面
                    locationStr = "bottom";
                  }
                });
              }
            } else if (centerCrossXDomList.length > 0 && isCustomModuleDomOut) {
              //此处只有要移动的组件完全在底部或者顶部的可能性
              centerCrossXDomList.forEach((userDefinedDomItem) => {
                const itemRectInfo = userDefinedDomItem.getBoundingClientRect();
                if (moveDomTopY > itemRectInfo.y + itemRectInfo.height) {
                  //在底部
                  if (moveDomTopY - itemRectInfo.y - itemRectInfo.height < minYNumber) {
                    minYDom = userDefinedDomItem;
                    minYNumber = moveDomTopY - itemRectInfo.y - itemRectInfo.height;
                    //当前元素下面
                    locationStr = "bottom";
                  }
                }
                if (moveDomBottomY < itemRectInfo.y) {
                  //在顶部
                  if (itemRectInfo.y - moveDomBottomY < minYNumber) {
                    minYDom = userDefinedDomItem;
                    minYNumber = itemRectInfo.y - moveDomBottomY;
                    //当前元素上面
                    locationStr = "top";
                  }
                }
              });
            }
            //容器
            userDefinedContainerDomList.forEach((userDefinedContainerDomItem) => {
              const itemRectInfo = userDefinedContainerDomItem.getBoundingClientRect();
              //中心点在容器内代表是要放到哪个容器中
              if (
                moveDomCenterX > itemRectInfo.x &&
                moveDomCenterX < itemRectInfo.x + itemRectInfo.width &&
                moveDomCenterY > itemRectInfo.y &&
                moveDomCenterY < itemRectInfo.y + itemRectInfo.height
              ) {
                hoverContainerDom = userDefinedContainerDomItem;
              }
            });
            // console.log(
            //   "🚀 ~ file: Page.vue:1206 ~ userDefinedContainerDomList.forEach ~ hoverContainerDom:",
            //   hoverContainerDom,
            //   userDefinedContainerDomList,
            //   {
            //     moveDomCenterX,
            //     moveDomCenterY,
            //     moveDomBottomY,
            //     moveDomLeftX,
            //     moveDomRightX,
            //     moveDomTopY,
            //   }
            // );
            if (switchUserCustomizationCommutant) {
              //代表是换位
              userDefinedContainerDomList.forEach((item) => {
                IDM.removeClasss(item, "idm_module_user_defined_placeholderstyle");
              });
              hoverContainerDom &&
                IDM.addClasss(
                  hoverContainerDom,
                  "idm_module_user_defined_placeholderstyle"
                );
            }
            //要判断是否  switchUserCustomizationCommutant  = true  换位，如果换位则需要给捕捉到的容器给一个遮罩层即可，就不用位移占位元素了
            let isEmptyContainerDom = hoverContainerDom.childElementCount == 0;
            if (hoverContainerDom.childElementCount == 1) {
              isEmptyContainerDom = hoverContainerDom.querySelector(
                "#idm_module_user_defined_placeholderbox"
              )
                ? true
                : false;
            }
            // idm_module_user_defined_placeholderbox
            if (minYDom && !switchUserCustomizationCommutant && !isEmptyContainerDom) {
              let parentDom = minYDom.parentElement;
              if (locationStr == "top") {
                parentDom.insertBefore(placeholderDom, minYDom);
              } else {
                //bottom
                if (parentDom.lastChild == minYDom) {
                  parentDom.appendChild(placeholderDom);
                } else {
                  parentDom.insertBefore(placeholderDom, minYDom.nextSibling);
                }
              }
            } else if (!switchUserCustomizationCommutant && isEmptyContainerDom) {
              //代表是空的
              hoverContainerDom.appendChild(placeholderDom);
            }
            // console.log("🚀 ~ file: Page.vue:1232 ~ pageUserDefinedStatusChangeHandle ~ minYDom:", minYDom,hoverContainerDom,placeholderDom)
          })
        : null;
      //松开事件
      !this.moduleMoveUpEvent
        ? (this.moduleMoveUpEvent = function (e) {
            e.stopPropagation();
            e.preventDefault();
            //要移除这些事件，否则会影响其他功能
            document.removeEventListener("mousemove", that.moduleMoveEvent);
            document.removeEventListener("mouseup", that.moduleMoveUpEvent);
            if (switchUserCustomizationCommutant && hoverContainerDom) {
              let lastElement = placeholderDom,
                parentDom = placeholderDom.parentElement;
              console.log(
                "🚀 ~ file: Page.vue ~ line 568 ~ moveUpEvent ~ hoverContainerDom",
                hoverContainerDom.childNodes
              );
              if (hoverContainerDom.childNodes) {
                const childElementCount = _.cloneDeep(
                  hoverContainerDom.childElementCount
                );
                for (let index = 0; index < childElementCount; index++) {
                  const element = hoverContainerDom.childNodes[0];
                  //更新结构
                  that.changePageSettingModuleSort(
                    element.id,
                    index == 0 ? currentMoveDom.id : lastElement.id,
                    "bottom"
                  );
                  //更新dom的data-idm-container-index
                  if (element.dataset.idmContainerIndex) {
                    element.dataset.idmContainerIndex = parentDom.getAttribute(
                      "idm-container-index"
                    );
                  }
                  parentDom.insertBefore(element, lastElement.nextSibling);
                  lastElement = element;
                }
              }
              //插入悬浮容器中
              hoverContainerDom.appendChild(currentMoveDom);
              //更新结构
              that.changePageSettingModuleSort(
                currentMoveDom.id,
                hoverContainerDom.getAttribute("idm-container-index"),
                "inner"
              );
            } else {
              let isEmptyContainerDom = hoverContainerDom.childElementCount == 0;
              if (hoverContainerDom.childElementCount == 1) {
                isEmptyContainerDom = hoverContainerDom.querySelector(
                  "#idm_module_user_defined_placeholderbox"
                )
                  ? true
                  : false;
              }
              //插入到占位前面
              placeholderDom.parentElement.insertBefore(currentMoveDom, placeholderDom);
              //更新结构
              minYDom && !isEmptyContainerDom
                ? that.changePageSettingModuleSort(
                    currentMoveDom.id,
                    minYDom.id,
                    locationStr
                  )
                : hoverContainerDom
                ? that.changePageSettingModuleSort(
                    currentMoveDom.id,
                    hoverContainerDom.getAttribute("idm-container-index"),
                    "inner"
                  )
                : null;
            }
            //移除占位
            $(placeholderDom).remove();
            //移除移动盒子
            $(moveDomBox).remove();
            //移除悬浮遮罩占位样式
            userDefinedContainerDomList.forEach((item) => {
              IDM.removeClasss(item, "idm_module_user_defined_placeholderstyle");
            });
            minYDom = null;
            locationStr = "";
            //发送组件消息
            IDM.broadcast.send({
              type: "resendAutoLayout",
              rangeModule: "",
              message: {},
            });
          })
        : null;
      //按下事件
      !this.moduleMousedownEvent
        ? (this.moduleMousedownEvent = function (e) {
            //所有容器Dom
            userDefinedContainerDomList = document
              .querySelector(`#router_page_${that.routerId}`)
              .querySelectorAll(
                ".drag_container[idm-ctrl-id='" + customModuleObject.id + "']"
              );
            e.stopPropagation();
            e.preventDefault();
            const packageid = e.target.dataset.packageid;
            if (!packageid) {
              return;
            }
            that.isChangeUserDefined = true;
            document.addEventListener("mousemove", that.moduleMoveEvent);
            document.addEventListener("mouseup", that.moduleMoveUpEvent);
            //要拷贝组件至绝对定位、注意组件的容器宽高是要跟现在保持一致的
            console.log("🚀 ~ file: Page.vue ~ line 397 ~ mousedownEvent ~ e", e);
            //获取当前packageid组件的实际宽高值
            currentMoveDom = document
              .querySelector(`#router_page_${that.routerId}`)
              .querySelector(`#${packageid}`);
            if (!currentMoveDom) {
              return;
            }
            const rectInfo = currentMoveDom.getBoundingClientRect();
            console.log(
              "🚀 ~ file: Page.vue ~ line 401 ~ mousedownEvent ~ rectInfo",
              rectInfo
            );
            //创建一个绝对定位的容器，用于存放剪切出来的组件
            moveDomBox = document.createElement("div");
            moveDomBox.id = "idm_module_user_defined_movebox";
            moveDomBox.className = "idm_module_user_defined_movebox";
            moveDomBox.style.width = rectInfo.width + "px";
            moveDomBox.style.height = rectInfo.height + "px";

            eleDiffPos.x = e.clientX - rectInfo.x;
            eleDiffPos.y = e.clientY - rectInfo.y;
            //要计算出位置与原来一模一样
            moveDomBox.style.left = e.clientX - eleDiffPos.x + "px";
            moveDomBox.style.top = e.clientY - eleDiffPos.y + "px";
            moveDomBox.style.position = "absolute";
            //创建一个同等宽的占位元素到currentMoveDom位置
            placeholderDom = document.createElement("div");
            placeholderDom.id = "idm_module_user_defined_placeholderbox";
            placeholderDom.className =
              "idm_module idm_module_user_defined_placeholderbox";
            // placeholderDom.style.width = "px";
            placeholderDom.style.height = rectInfo.height + "px";
            placeholderDom.dataset.styleHeight = rectInfo.height + "px";
            currentMoveDom.parentElement.insertBefore(placeholderDom, currentMoveDom);
            moveDomBox.appendChild(currentMoveDom);
            document.body.appendChild(moveDomBox);

            userDefinedDomList = document
              .querySelector(`#router_page_${that.routerId}`)
              .querySelectorAll(".idm_module_user_defined");
          })
        : null;
      //所有容器Dom
      userDefinedContainerDomList = document
        .querySelector(`#router_page_${that.routerId}`)
        .querySelectorAll(".drag_container[idm-ctrl-id='" + customModuleObject.id + "']");
      that.registerModuleMouseDownEvent();
      if (save && this.pageUserDefinedStatus === false) {
        this.userDefinedSave();
      }
    },
    /**
     * 注册组件事件
     * registerPackageid:要注册的组件ID
     */
    registerModuleMouseDownEvent(registerPackageid) {
      let that = this;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      this.customModuleObject.children &&
        this.customModuleObject.children.forEach((module) => {
          if (registerPackageid && registerPackageid !== module.packageid) {
            return;
          }
          //对组件进行添加事件、Dom、移除事件、Dom
          let moduleDom = $(`#router_page_${that.routerId} #${module.packageid}`),
            moduleElement = document
              .querySelector(`#router_page_${that.routerId}`)
              .querySelector(`#${module.packageid}`);
          if (!moduleElement) {
            return;
          }
          if (that.pageUserDefinedStatus) {
            const marginLeft = moduleDom
                .find(">div[idm-ctrl='idm_module']")
                .css("marginLeft"),
              marginRight = moduleDom
                .find(">div[idm-ctrl='idm_module']")
                .css("marginRight");
            if (moduleDom.find(">div.idm_module_user_defined").length > 0) {
              return;
            }
            let userDefinedDom = document.createElement("div");
            userDefinedDom.className = "idm_module_user_defined";
            userDefinedDom.style.marginLeft = marginLeft;
            userDefinedDom.style.marginRight = marginRight;
            userDefinedDom.dataset.packageid = module.packageid;

            if (!propData.switchUserCustomizationCommutant) {
              //不是换位就需要能把组件删除
              userDefinedDom.innerHTML = `
            <div title="移除组件">
            <svg t="1659629683475" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9221" width="16" height="16"><path d="M576 512l277.333333 277.333333-64 64-277.333333-277.333333L234.666667 853.333333 170.666667 789.333333l277.333333-277.333333L170.666667 234.666667 234.666667 170.666667l277.333333 277.333333L789.333333 170.666667 853.333333 234.666667 576 512z" p-id="9222"></path></svg>
            </div>
            `;
              userDefinedDom.querySelector("div").addEventListener("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                //移除组件 hidden=true
                let hiddenPackageid = e.currentTarget.parentElement.dataset.packageid;
                that.customModuleObject.children.forEach((iitem) => {
                  if (iitem.packageid == hiddenPackageid) {
                    iitem.hidden = true;
                  }
                });
                let lsmodule = that.getModuleTree(
                  that.originalUserCustomizationModuleObject,
                  hiddenPackageid
                );
                lsmodule ? (lsmodule.hidden = true) : null;
                that.$forceUpdate();
                $(
                  document
                    .querySelector(`#router_page_${that.routerId}`)
                    .querySelector(`#${hiddenPackageid}`)
                ).remove();
              });
            } else {
              userDefinedDom.innerHTML = `
            <div title="设置要显示的组件">
            <svg t="1660125485320" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23286" width="16" height="16"><path d="M510.37806 337.803609c-98.010221 0-177.748287 78.842673-177.748287 175.75284 0 96.91426 79.738066 175.763073 177.748287 175.763073 9.537214 0 19.620873-0.978281 31.797194-3.088338 18.196431-3.281743 30.290887-20.538779 26.963095-38.471197-2.924609-15.732309-16.693194-27.152407-32.747845-27.152407-2.071172 0-4.15974 0.196475-6.123464 0.563842-7.937786 1.402953-14.233166 2.056845-19.807115 2.056845-61.159942 0-110.915136-49.201585-110.915136-109.671819 0-60.467163 49.679469-109.661585 110.747313-109.661585 61.116963 0 110.832248 49.194422 110.832248 109.661585 0 5.892197-0.656963 12.0832-2.088568 19.531845-3.327792 17.928325 8.769734 35.189454 26.959002 38.464033 2.006703 0.360204 4.045129 0.546446 6.070252 0.546446 16.204054 0 30.019711-11.43033 32.832779-27.116591 2.13871-11.45182 3.13848-21.435195 3.13848-31.41857 0.042979-46.873564-18.435884-90.990341-52.033074-124.223233C602.407056 356.106464 557.790906 337.803609 510.37806 337.803609zM938.476161 432.79917c-2.185782-11.426237-11.037381-20.499893-22.563902-23.12058-41.909505-9.508561-76.781734-34.929534-98.185206-71.550593-21.334911-36.560684-26.191522-79.099523-13.68979-119.709429 3.52836-11.123338 0.007163-23.235191-8.951883-30.840402-41.860387-35.721573-89.536222-62.938448-141.695163-80.885192-3.152806-1.088798-6.437619-1.639337-9.776667-1.639337-8.256034 0-16.182564 3.431146-21.724791 9.376555-29.236881 31.04404-68.840878 48.140417-111.5107 48.140417-42.673915 0-82.305541-17.125029-111.607914-48.230468-7.877411-8.333806-20.510126-11.512195-31.580253-7.726985-52.483328 18.171871-100.131535 45.416376-141.640927 80.988546-8.815783 7.591909-12.322653 19.620873-8.934486 30.67258 12.586666 40.645722 7.759731 83.180468-13.597693 119.78106-21.306258 36.5965-56.149834 62.006216-98.17395 71.561849-11.540847 2.709715-20.396539 11.812023-22.559808 23.166629-5.228071 27.169803-7.877411 54.346769-7.877411 80.770582 0 26.426883 2.64934 53.603849 7.873318 80.763418 2.174526 11.411911 11.023054 20.488637 22.552645 23.12058 41.913599 9.512654 76.785827 34.922371 98.19237 71.547523 21.349237 36.59343 26.177196 79.128175 13.583366 119.795387-3.363607 10.969842 0.121773 23.013133 8.973372 30.758538 41.84913 35.707246 89.494267 62.920028 141.662417 80.902588 11.466146 3.885494 23.738657 0.549515 31.454386-7.680936 29.29828-31.091112 68.925812-48.216141 111.593588-48.216141s82.302471 17.125029 111.560842 48.183396c5.556553 5.955642 13.494339 9.380648 21.782096 9.380648 3.27765 0 6.537903-0.520863 9.829879-1.599428 52.126194-17.968234 99.774401-45.184085 141.652184-80.912821 8.791224-7.577582 12.308327-19.628036 8.94165-30.758538-12.597923-40.678468-7.745405-83.20605 13.672394-119.773897 21.324678-36.625152 56.192813-62.030775 98.19237-71.547523 11.390421-2.592035 20.23588-11.633968 22.549575-23.106254 5.223978-27.184129 7.870248-54.358025 7.870248-80.770582C946.342316 487.171522 943.697069 459.965903 938.476161 432.79917zM728.572524 789.878798c-26.02677 20.157085-54.736649 36.553521-85.487 48.818869-36.682457-32.144094-83.60207-49.779753-132.792399-49.779753-48.926316 0-95.838765 17.635659-132.767839 49.786916-30.744211-12.262278-59.45716-28.655643-85.491093-48.812729 9.894348-47.441499 1.889023-96.449679-22.763446-138.627291-24.448832-41.966811-63.427588-73.339332-110.186542-88.840374-2.381234-16.343223-3.584642-32.758078-3.584642-48.869011 0-16.043395 1.203408-32.451086 3.584642-48.851615 46.612621-15.389502 85.584214-46.758953 110.186542-88.850607 24.523533-42.024116 32.525788-91.033319 22.74912-138.620128 26.0237-20.149922 54.735625-36.543288 85.494163-48.815799 36.821627 32.201399 83.73817 49.861618 132.778072 49.861618 49.194422 0 96.109941-17.635659 132.792399-49.779753 30.751375 12.269441 59.45716 28.662807 85.48086 48.812729-9.809413 47.63388-1.835811 96.634898 22.667256 138.620128 24.445762 41.966811 63.416332 73.343425 110.182448 88.850607 2.381234 16.386202 3.584642 32.801057 3.584642 48.940642 0.143263 15.443737-1.031493 31.797194-3.499707 48.701189-46.763047 15.504112-85.73771 46.873564-110.186542 88.836281C726.84416 693.189665 718.845998 742.190683 728.572524 789.878798z" p-id="23287"></path></svg>
            </div>
            `;
              userDefinedDom.querySelector("div").addEventListener("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                //显示替换窗口
                let currentPackageid = e.currentTarget.parentElement.dataset.packageid;
                that.pageUserDefinedModalVisible = true;
                that.currentContainerShowPackageid = currentPackageid;
                that.currentContainerShowModuleObject = that.getModuleTree(
                  that.PageSettingData.page.layout.children,
                  currentPackageid
                );
                that.currentContainerShowModuleName =
                  (that.currentContainerShowModuleObject.props &&
                    that.currentContainerShowModuleObject.props.compositeAttr &&
                    that.currentContainerShowModuleObject.props.compositeAttr.title) ||
                  that.currentContainerShowModuleObject.asName;
              });
            }
            moduleElement.appendChild(userDefinedDom);
            //给组件注册拖拽事件等等
            moduleElement.addEventListener("mousedown", that.moduleMousedownEvent);
          } else {
            moduleElement &&
              $(moduleElement.querySelector(".idm_module_user_defined")).remove();
            //取消组件的事件绑定
            moduleElement &&
              moduleElement.removeEventListener("mousedown", that.moduleMousedownEvent);
          }
        });
      if (propData.switchUserCustomizationCommutant) {
        //如果是组件换位则需要对空容器添加 点击添加组件的dom和样式
        const customModuleContainerList = document
          .querySelector(`#router_page_${that.routerId}`)
          .querySelectorAll(
            ".drag_container[idm-ctrl-id='" + this.customModuleObject.id + "']"
          );
        for (let index = 0; index < customModuleContainerList?.length; index++) {
          const element = customModuleContainerList[index];
          if (!that.pageUserDefinedStatus) {
            element &&
              $(element.querySelector(".idm_module_user_defined_placeholder")).remove();
            continue;
          }
          if (element && element.childElementCount === 0) {
            //没有组件，需要追加添加样式
            let userDefinedDom = document.createElement("div");
            userDefinedDom.className = "idm_module_user_defined_placeholder";
            userDefinedDom.innerHTML = ``;
            userDefinedDom.dataset.idmContainerIndex = element.getAttribute(
              "idm-container-index"
            );
            element.appendChild(userDefinedDom);
            userDefinedDom.addEventListener("click", function (e) {
              e.stopPropagation();
              e.preventDefault();
              //显示替换窗口
              let currentPackageid = "";
              that.pageUserDefinedModalVisible = true;
              that.currentContainerShowPackageid = currentPackageid;
              that.currentContainerShowModuleObject = null;
              that.currentContainerShowModuleName = "";
              that.currentContainerShowModuleContainerIndex =
                e.currentTarget.dataset.idmContainerIndex;
            });
          } else if (element && element.childElementCount === 2) {
            element &&
              $(element.querySelector(".idm_module_user_defined_placeholder")).remove();
          }
        }
      }
    },
    /**
     * moveModuleId：要移动的组件packageid
     * tragetModuleId：要移动到相关位置的组件packageid，如果position为inner则此处的id为容器的编号
     * position：位置：top、bottom、inner
     *
     */
    changePageSettingModuleSort(moveModuleId, tragetModuleId, position) {
      //
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      //首先找出要自定义的容器组件
      /**
       * 组件范围选择返回的格式：
       * [
       *  {
       *  moduleId:packageid,
       *  moduleName:asName
       *  }
       * ]
       */
      const customContainerModuleId =
        propData.userCustomizationModuleContainer &&
        propData.userCustomizationModuleContainer.length > 0
          ? propData.userCustomizationModuleContainer[0].moduleId
          : "";
      let customModuleObject = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        customContainerModuleId
      );
      if (!customModuleObject) {
        return false;
      }
      let moveModuleIndex = -1,
        tragetModuleIndex = -1;
      customModuleObject.children &&
        customModuleObject.children.forEach((item, index) => {
          if (item.packageid == moveModuleId && position == "inner") {
            item.containerIndex = tragetModuleId;
            if (item.relationType && item.relationType.startsWiths("inner_")) {
              item.relationType = "inner_" + tragetModuleId;
            }
          }
          if (item.packageid == moveModuleId) {
            moveModuleIndex = index;
          }
          if (item.packageid == tragetModuleId) {
            tragetModuleIndex = index;
          }
        });
      if (tragetModuleIndex > -1 && moveModuleIndex > -1 && position != "inner") {
        customModuleObject.children[moveModuleIndex].containerIndex =
          customModuleObject.children[tragetModuleIndex].containerIndex;
        customModuleObject.children[moveModuleIndex].relationType = position;
        customModuleObject.children[moveModuleIndex].relationId = tragetModuleId;

        customModuleObject.children.splice(
          tragetModuleIndex + (position == "bottom" ? 1 : 0),
          0,
          customModuleObject.children[moveModuleIndex]
        );
        customModuleObject.children.splice(
          moveModuleIndex + (tragetModuleIndex < moveModuleIndex ? 1 : 0),
          1
        );
      }
    },

    /**
     * 移除用户定制选择的
     */
    removeUserDefinedSelect(item) {
      let that = this;
      item.hidden = true;
      let lsmodule = that.getModuleTree(
        this.PageSettingData.page.layout.children,
        item.packageid
      );
      lsmodule ? (lsmodule.hidden = true) : null;
      that.$forceUpdate();
      $(
        document
          .querySelector(`#router_page_${that.routerId}`)
          .querySelector(`#${item.packageid}`)
      ).remove();
    },
    /**
     * 添加用户选择的组件
     */
    addUserDefinedSelect(item) {
      //添加完成后
      let that = this;
      item.hidden = false;
      let lsmodule = that.getModuleTree(
        this.PageSettingData.page.layout.children,
        item.packageid
      );
      //组件不存在的时候需要追加
      if (!lsmodule) {
        let propData = this.PageSettingData.page.layout.props.compositeAttr;
        const customContainerModuleId =
          propData.userCustomizationModuleContainer &&
          propData.userCustomizationModuleContainer.length > 0
            ? propData.userCustomizationModuleContainer[0].moduleId
            : "";
        let customContainerModule = that.getModuleTree(
          this.PageSettingData.page.layout.children,
          customContainerModuleId
        );
        lsmodule = _.cloneDeep(item);
        customContainerModule.children.push(lsmodule);
      }

      lsmodule ? (lsmodule.hidden = false) : null;
      that.$forceUpdate();
      //重新加载组件
      that.moduleReload(item.packageid);
      //重新加载组件需要修改组件的排序
      //找出当前索引的最后一个
      let lastModule;
      this.customModuleObject.children &&
        this.customModuleObject.children.forEach((module) => {
          if (
            module.containerIndex == lsmodule.containerIndex &&
            module.hidden !== true
          ) {
            lastModule = module;
          }
        });
      //要重新排序的
      if (lastModule) {
        that.changePageSettingModuleSort(item.packageid, lastModule.packageid, "bottom");
      } else {
        that.changePageSettingModuleSort(
          item.packageid,
          lsmodule.containerIndex,
          "inner"
        );
      }
      if (
        lsmodule &&
        this.customModuleObject.children?.filter(
          (ftem) => ftem.packageid == lsmodule.packageid
        ).length == 0
      ) {
        this.customModuleObject.children.push(lsmodule);
      }
      //加载完毕后还需要重新注册事件
      that.registerModuleMouseDownEvent(item.packageid);
    },
    /**
     * 组件替换功能
     * item:要替换的对象
     * type:替换的类型：replace 和隐藏域的组件替换， changeseats 跟当前组件换位，add 添加隐藏域的组件
     */
    userDefinedModuleReplace(item, type) {
      let that = this;
      let orgcontainerIndex = that.currentContainerShowModuleContainerIndex;
      if (that.currentContainerShowModuleObject) {
        orgcontainerIndex = that.currentContainerShowModuleObject.containerIndex;
        //把当前容器的组件移出，如果type=replace 则和999999999的容器序号替换，反之和当前容器的进行替换
        that.currentContainerShowModuleObject.containerIndex = item.containerIndex;
        that.currentContainerShowModuleObject.relationType = item.relationType;
        that.currentContainerShowModuleObject.relationId = item.relationId;
      }
      //把当前选中的组件移到当前组件所在的容器位置
      that.changePageSettingModuleSort(item.packageid, orgcontainerIndex, "inner");
      item.relationType = "inner_" + orgcontainerIndex;

      if (type == "changeseats") {
        //需要先移除被换位的，然后再渲染
        $(
          document
            .querySelector(`#router_page_${that.routerId}`)
            .querySelector(`#${item.packageid}`)
        ).remove();
      }
      //把要当前替换的全部移除，然后再渲染
      that.currentContainerShowModuleObject &&
        $(
          document
            .querySelector(`#router_page_${that.routerId}`)
            .querySelector(`#${that.currentContainerShowModuleObject.packageid}`)
        ).remove();
      //重新加载组件
      that.moduleReload(item.packageid);
      //加载完毕后还需要重新注册事件
      that.registerModuleMouseDownEvent(item.packageid);
      if (type == "changeseats") {
        //重新加载组件
        that.moduleReload(that.currentContainerShowModuleObject.packageid);
        //加载完毕后还需要重新注册事件
        that.registerModuleMouseDownEvent(
          that.currentContainerShowModuleObject.packageid
        );
      }
      that.pageUserDefinedModalVisible = false;
      //发送组件消息
      IDM.broadcast.send({
        type: "resendAutoLayout",
        rangeModule: "",
        message: {},
      });
    },
    /**
     * 用户个性化定制保存
     */
    userDefinedSave() {
      let that = this;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;

      if (
        propData.customizationToolBarSaveEvent &&
        propData.customizationToolBarSaveEvent.length > 0
      ) {
        let resultBack = this.commonCustomEventFunHandle(
          propData,
          "customizationToolBarSaveEvent",
          {
            pageData: this.PageSettingData.page,
            routerId: that.routerId,
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
          }
        );
        if (resultBack === false) {
          return;
        }
      }
      that.userDefinedSaveLoading = true;

      const customContainerModuleId =
        propData.userCustomizationModuleContainer &&
        propData.userCustomizationModuleContainer.length > 0
          ? propData.userCustomizationModuleContainer[0].moduleId
          : "";

      let customModuleObject = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        customContainerModuleId
      );
      if (!customModuleObject) {
        that.userDefinedSaveLoading = false;
        return false;
      }

      let saveNewData = _.cloneDeep(customModuleObject);
      this.deleteLayoutAttachAttr(saveNewData);
      //保存到数据库中
      propData.userCustomizationSaveUrl &&
        IDM.http
          .post(propData.userCustomizationSaveUrl, {
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
            customData: JSON.stringify(saveNewData),
          })
          .then((res) => {
            res = res ? res.data : {};
            that.userDefinedSaveLoading = false;
            if (res.code !== "200") {
              IDM.message.error("个性化定制保存失败！message：" + res.message);
              return;
            }
            IDM.message.success("保存成功！");
            //保存成功
            IDM.page.changePageUserDefinedStatus({
              routerId: that.routerId,
              status: false,
            });
          })
          .catch((error) => {
            IDM.message.error("个性化定制保存失败！message：" + error.message);
            that.userDefinedSaveLoading = false;
          });
    },
    /**
     * 用户个性化定制重置
     */
    userDefinedReset() {
      let that = this;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;

      if (
        propData.customizationToolBarResetEvent &&
        propData.customizationToolBarResetEvent.length > 0
      ) {
        let resultBack = this.commonCustomEventFunHandle(
          propData,
          "customizationToolBarResetEvent",
          {
            pageData: this.PageSettingData.page,
            routerId: that.routerId,
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
          }
        );
        if (resultBack === false) {
          return;
        }
      }

      that.userDefinedSaveLoading = true;

      //保存到数据库中
      propData.userCustomizationSaveUrl &&
        IDM.http
          .post(propData.userCustomizationSaveUrl, {
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
            reset: 1,
          })
          .then((res) => {
            res = res ? res.data : {};
            if (res.code !== "200") {
              that.userDefinedSaveLoading = false;
              IDM.message.error("重置操作失败！message：" + res.message);
              return;
            }
            IDM.message.success("重置成功！3秒后即将刷新本页面。");
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          })
          .catch((error) => {
            IDM.message.error("重置操作失败！message：" + error.message);
            that.userDefinedSaveLoading = false;
          });
    },
    /**
     * 用户个性化定制退出
     */
    userDefinedQuit() {
      let that = this;
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      if (
        propData.customizationToolBarQuitEvent &&
        propData.customizationToolBarQuitEvent.length > 0
      ) {
        let resultBack = this.commonCustomEventFunHandle(
          propData,
          "customizationToolBarQuitEvent",
          {
            pageData: this.PageSettingData.page,
            routerId: that.routerId,
            pageid: this.pageid,
            version: this.PageSettingData.pageBaseInfo.version,
          }
        );
        if (resultBack === false) {
          return;
        }
      }
      //不保存当前的数据，重新刷新当前页面
      if (this.isChangeUserDefined === true) {
        window.location.reload();
      } else {
        IDM.page.changePageUserDefinedStatus({ routerId: this.routerId, status: false });
      }
    },
    /**
     * 遮罩层直接关闭窗口
     */
    layerClickHandle(item, e) {
      let dialogId = item ? item.packageid : "";
      if (!dialogId) {
        return;
      }
      //获取shadeClose是否支持关闭
      if (
        item &&
        item.props &&
        item.props.compositeAttr &&
        item.props.compositeAttr.shadeClose === false
      ) {
        return;
      }
      window.IdmBuiltin_CloseDialog({
        routerId: this.routerId,
        targetModule: [{ moduleId: dialogId }],
      });
    },
    /**
     * 动态检查是否加载react文件或其他文件
     */
    async initReactOrOtherLib(react) {
      //判断是否已经加载过
      if (react && !IDM.router.getReact()) {
        IDM.router.setReact();
        //动态加载react文件
        await IDM.http
          .importFiles([
            IDM.url.getWebPath("~/lib/react.min.js"),
            IDM.url.getWebPath("~/lib/react-dom.min.js"),
          ])
          .then(() => {
            //加载完成
            console.log("react文件加载成功");
          })
          .catch((err) => {
            console.log("react文件加载出错");
          });
      }
    },
    /**
     * 组件加载之前执行
     */
    beforeLoadingFunction() {
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      if (propData.beforeLoadingFunction && propData.beforeLoadingFunction.length > 0) {
        this.commonCustomEventFunHandle(propData, "beforeLoadingFunction");
      }
    },
    /**
     * 组件加载完后执行
     */
    afterLoadingFunction() {
      let propData = this.PageSettingData.page.layout.props.compositeAttr;
      if (propData.afterLoadingFunction && propData.afterLoadingFunction.length > 0) {
        this.commonCustomEventFunHandle(propData, "afterLoadingFunction");
      }
    },
    /**
     * 页面请求组件之前加载页面接口处理事件
     * @param {*} callback
     */
    requestPageCommonInterfaceDataBeforeHandle(callback) {
      var interfaceList =
        (this.PageSettingData.page.layout.props.compositeAttr
          ? this.PageSettingData.page.layout.props.compositeAttr.interfaceList
          : []) || [];
      if (interfaceList.length == 0) {
        callback && callback();
        return;
      }
      interfaceList = interfaceList.filter(
        (item) => item.loadTimingType == "pageloadbefore"
      );
      if (interfaceList.length == 0) {
        callback && callback();
        return;
      }
      this.orderlyRequestInterface(interfaceList, 0, this.InterfaceParam(), callback);
    },
    /**
    页面请求组件之前加载接口
     */
    requestPageCommonInterfaceDataBefore(callback) {
      const propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      const that = this;
      this.requestPageCommonInterfaceDataBeforeHandle(() => {
        if (propData?.openFormMode && propData?.formInitDataApi) {
          //已经开启是表单模式
          that.initFormDataToIdmVar(callback);
        } else {
          callback && callback();
        }
      });
    },
    /**
     * 加载表单数据到IDM对象变量中
     * @param {*} callback
     */
    initFormDataToIdmVar(callback) {
      const propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      const that = this;
      const requestType = propData?.formInitRequestType || "get";
      const contentType = propData?.formInitContentType || "";
      const extendParamList = propData?.formInitExtendParamList || [];
      const formDataName = IDM.setting.form.initApiParamNameSetting.formData;
      let param = {
        [formDataName]: IDM.url.queryObject()[formDataName],
        [IDM.setting.form.initApiParamNameSetting.formId]: this.pageid,
      };
      extendParamList.forEach((item) => {
        if(item.paramFunction&&item.paramFunction.length){
          let result = IDM.invokeCustomFunctions.apply(this, [
            item.paramFunction,
              {}
            ]);
          param[item.paramKey] = result && result.length > 0?result[0]:"";
          return;
        }
        param[item.paramKey] = IDM.express.replace(item.paramVal,{IDM: IDM, window});
      });
      let headerObject = null;
      if(contentType){
        headerObject = {
          headers:{
            "Content-Type":contentType
          }
        }
      }
      IDM.http[requestType](propData?.formInitDataApi, param,headerObject).then(res=>{
        if(res&&res.data){
          //给IDM.form赋值
          IDM.form.setQueryObject(IDM.getExpressData(propData.formInitResultQueryObject,res.data))
          IDM.form.setMetaConfig(IDM.getExpressData(propData.formInitResultMetaConfig,res.data))
          IDM.form.setComponentData(IDM.getExpressData(propData.formInitResultComponentData,res.data))
          IDM.form.setFormData(IDM.getExpressData(propData.formInitResultFormData,res.data))
          IDM.form.setRoleData(IDM.getExpressData(propData.formInitResultRoleData,res.data))
        }else{
          IDM.message.error("加载表单初始化接口失败！原因：未正确返回结果")
        }
        callback&&callback();
      }).catch(function (error) {
        IDM.message.error("加载表单初始化接口失败！"+error.message)
        callback&&callback();
      });
    },
    /**
     * 请求页面设置的所有接口并回调给每个组件
     * @param {*} checkFirstLoad 判断是否需要进行首次加载后续不加载的判断
     */
    requestPageCommonInterfaceData(checkFirstLoad) {
      //调用桥接器页面加载(包括实时渲染)完成事件
      this.IDM.broadcast.pageLoadCompleteAfter(this.routerId);
      if (checkFirstLoad && this.pageCommonInterfaceLoaded) {
        return;
      }
      this.pageCommonInterfaceLoaded = true;
      const linkList = this.PageSettingData.page.linkList || [];
      if (linkList.length) {
        //判断是否需要加载连线
        let propData = this.PageSettingData.page.layout.props.compositeAttr || {};
        if (propData.openJsPlumb === true) {
          //加载完成了
          this.reconnectionAllModule();
        }
      }
      console.log("页面首屏组件已全部加载完毕！！！");
      this.afterLoadingFunction();

      const interfaceList = (
        this.PageSettingData.page.layout.props.compositeAttr?.interfaceList ?? []
      ).filter((item) => !item.loadTimingType || item.loadTimingType === "pageloadlater");
      if (!interfaceList.length) {
        return;
      }
      this.orderlyRequestInterface(interfaceList, 0, this.InterfaceParam());
    },
    /**
    接口请求的所有参数 */
    InterfaceParam() {
      //先获取页面ID，然后再获取所有的组件ID
      var pageId = this.pageid;
      var moduleIdArray = [],
        componentIdArray = [];
      this.PageSettingData.page.componentsMap.forEach((item) => {
        if (item.packageid != pageId) {
          moduleIdArray.push(item.packageid);
          componentIdArray.push(item.comId);
        }
      });
      //所有地址的url参数转换
      var params = {
        idmPageId: pageId,
        moduleIds: moduleIdArray.join(","),
        componentIds: componentIdArray.join(","),
      };
      let urlObject = IDM.url.queryObject();
      Object.keys(urlObject).forEach((key) => {
        params[key] = urlObject[key];
      });
      return params;
    },
    /**
     * 有序的加载接口并且回调各个组件
     */
    orderlyRequestInterface(interfaceList, index, params, callback, linkMessageObject) {
      if (interfaceList.length <= index) {
        callback && callback();
        return;
      }
      var item = interfaceList[index];
      index = index + 1;
      let that = this;
      //linkMessageObject不为空则去判断是否需要重新请求接口
      if (linkMessageObject) {
        //根据过滤条件进行匹配
        let _isPass = false;
        try {
          if (item.reloadType == "express") {
            _isPass = IDM.express.replace("@[" + item.reloadExpression + "]", {
              IDM: IDM,
              window,
              linkMessageObject,
            });
          } else if (
            item.reloadType == "customFunction" &&
            item.reloadCustomFunction &&
            item.reloadCustomFunction.length > 0
          ) {
            let itemParam = {
              ...that.commonParam(),
              ...item.reloadCustomFunction[0].param,
              linkMessageObject,
            };
            _isPass =
              window[item.reloadCustomFunction[0].name] &&
              window[item.reloadCustomFunction[0].name].call(this, itemParam);
          }
        } catch (error) {}
        if (!_isPass) {
          that.orderlyRequestInterface(
            interfaceList,
            index,
            params,
            callback,
            linkMessageObject
          );
          return;
        }
      }
      // preAllowFunction
      if (item.preAllowFunction && item.preAllowFunction.length > 0) {
        try {
          let itemParam = {
            ...that.commonParam(),
            ...item.preAllowFunction[0].param,
            linkMessageObject,
          };
          let _isPass =
            window[item.preAllowFunction[0].name] &&
            window[item.preAllowFunction[0].name].call(this, itemParam);
          if (_isPass === false) {
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
            return;
          }
        } catch (error) {}
      }

      //请求数据源的方式
      if (item.formDataFunction && item.formDataFunction.length > 0) {
        try {
          let itemParam = {
            ...that.commonParam(),
            ...item.formDataFunction[0].param,
            linkMessageObject,
          };
          let formDataParam =
            window[item.formDataFunction[0].name] &&
            window[item.formDataFunction[0].name].call(this, itemParam);
          params = { ...params, ...formDataParam };
        } catch (error) {}
      }

      if (
        item.interfaceType == "datasource" &&
        item.dataSourceSelectData &&
        item.dataSourceSelectData.length
      ) {
        IDM.datasource.request(
          item.dataSourceSelectData[0].id,
          {
            moduleObject: {},
            param: params,
            linkMessageObject,
          },
          function (resData) {
            //这里是请求成功的返回结果
            that.callbackModuleSetContext(item, resData);
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          },
          function (error) {
            //这里是请求失败的返回结果
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          }
        );
      } else if (item.interfaceMode == "post" && item.interfaceUrl) {
        this.$previewApi
          .postPageInterfaceInfo(item.interfaceUrl, params, {
            headers: item.interfaceContentType
              ? {
                  "Content-Type":
                    item.interfaceContentType || "application/json;charset=UTF-8",
                }
              : {},
          })
          .then((res) => {
            //res.data
            //循环调用组件接收数据的方法
            that.callbackModuleSetContext(item, res.data || res);
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          })
          .catch(function (error) {
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          });
      } else if (item.interfaceMode == "get" && item.interfaceUrl) {
        this.$previewApi
          .getPageInterfaceInfo(item.interfaceUrl, params)
          .then((res) => {
            //res.data
            //循环调用组件接收数据的方法
            that.callbackModuleSetContext(item, res.data || res);
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          })
          .catch(function (error) {
            that.orderlyRequestInterface(
              interfaceList,
              index,
              params,
              callback,
              linkMessageObject
            );
          });
      } else {
        that.orderlyRequestInterface(
          interfaceList,
          index,
          params,
          callback,
          linkMessageObject
        );
      }
    },
    /**
     * 回调组件的设置值的方法
     */
    callbackModuleSetContext(item, resData) {
      //设置页面统一接口结果到data中,等接口全部请求完后再发送消息给每个组件
      this.pageInterfaceResultObject[item.resultDataName] = resData;
      this.sendBroadcastMessage({
        type: "pageCommonInterface",
        message: resData,
        messageKey: item.resultDataName,
        rangeModule: "",
      });
      if (item.loadTimingType != "pageloadbefore") {
        //加载之后执行
        this.PageSettingData.page.componentsMap.forEach((sitem) => {
          sitem.idmSetContextValue &&
            sitem.idmSetContextValue({
              type: "pageCommonInterface",
              key: item.resultDataName,
              data: resData,
            });
        });
      }
      //自定义处理返回结果函数
      if (item.interfaceRunLaterFunction && item.interfaceRunLaterFunction.length > 0) {
        var interfaceRunLaterFunction = item.interfaceRunLaterFunction;
        interfaceRunLaterFunction.forEach((sitem) => {
          try {
            window[sitem.name] &&
              window[sitem.name].call(this, {
                ...this.commonParam(),
                customParam: sitem.param,
                resultData: resData,
                _this: this,
              });
          } catch (error) {}
        });
      }
      let propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      //应用主题：页面结果集
      if (
        this.mainPage &&
        propData.openIdmTheme &&
        propData.themeFetchType == "pageInterfaceResult" &&
        propData.themeDataName &&
        item.resultDataName == propData.themeDataName
      ) {
        this.themeInterfaceHandle(resData, propData.themeDataName);
      }
    },
    /**
     * 渲染页面的样式
     */
    pageAttrPropHandle(propDataObject) {
      let propData = propDataObject.compositeAttr;
      this.pagePropData = propData;
      var styleObject = {};
      if (!propData.bgList?.bgList?.length) {
        if (propData.bgSize && propData.bgSize == "custom") {
          styleObject["background-size"] =
            (propData.bgSizeWidth
              ? propData.bgSizeWidth.inputVal + propData.bgSizeWidth.selectVal
              : "auto") +
            " " +
            (propData.bgSizeHeight
              ? propData.bgSizeHeight.inputVal + propData.bgSizeHeight.selectVal
              : "auto");
        } else if (propData.bgSize) {
          styleObject["background-size"] = propData.bgSize;
        }
        if (propData.positionX && propData.positionX.inputVal) {
          styleObject["background-position-x"] =
            propData.positionX.inputVal + propData.positionX.selectVal;
        }
        if (propData.positionY && propData.positionY.inputVal) {
          styleObject["background-position-y"] =
            propData.positionY.inputVal + propData.positionY.selectVal;
        }
      }
      for (const key in propData) {
        if (propData.hasOwnProperty.call(propData, key)) {
          const element = propData[key];
          if (!element && element !== false) {
            continue;
          }
          switch (key) {
            case "defaultIdmTheme":
              if (!this.themeSetObject && this.mainPage) {
                IDM.theme.setCurrentThemeInfo(element);
                this.themeSetObject = element;
              }
              break;
            case "width":
            case "height":
              styleObject[key] = element;
              break;
            case "bgColor":
              if (element.hex8) {
                styleObject["background-color"] =
                  IDM.hex8ToRgbaString(element.hex8) + "  !important";
              }
              break;
            case "box":
              IDM.style.setBoxStyle(styleObject, element);
              break;
            case "bgImgUrl":
              if (!propData.bgList?.bgList?.length) {
                styleObject["background-image"] = `url(${IDM.url.getWebPath(element)})`;
              }
              break;
            case "icoImgUrl":
              try {
                document.head
                  .querySelector("link[rel='icon']")
                  .setAttribute("href", IDM.url.getWebPath(element));
              } catch (error) {}
              //IDM.url.getWebPath(element)
              var link = document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = IDM.url.getWebPath(element);
              document.getElementsByTagName("head")[0].appendChild(link);
              break;
            case "positionX":
              //背景横向偏移

              break;
            case "positionY":
              //背景纵向偏移

              break;
            case "bgRepeat":
              //平铺模式
              if (!propData.bgList?.bgList?.length) {
                styleObject["background-repeat"] = element;
              }
              break;
            case "bgAttachment":
              //背景模式
              if (!propData.bgList?.bgList?.length) {
                styleObject["background-attachment"] = element;
              }
              break;
            case "border":
              IDM.style.setBorderStyle(styleObject, element);
              break;
            case "font":
              IDM.style.setFontStyle(styleObject, element);
              break;
            case "layout":
              IDM.style.setLayoutStyle(styleObject, element);
              break;
            case "pageMinWidth":
              if (element.inputVal && element.selectVal) {
                styleObject["min-width"] = element.inputVal + element.selectVal;
              }
              break;
            case "bgList":
              if (element && element.style && Object.keys(element.style).length) {
                Object.assign(styleObject, element.style);
              }
              break;
          }
        }
      }
      //滤镜样式设置
      let filterStyleObject = {};
      IDM.style.setFilterStyle(filterStyleObject, propDataObject.basicAttr, {
        opacity: "pageOpacity",
      });
      IDM.setStyleToPageHead("router_page_" + this.routerId, filterStyleObject);

      this.$nextTick(function (params) {
        if (propData.watermarkType && propData.watermarkType != "none") {
          var _watermarkFont = this.$replace(propData.watermarkFont, {
              IDM: IDM,
            }),
            _watermarkFont1 = this.$replace(propData.watermarkFont1, {
              IDM: IDM,
            });
          //文字水印
          IDM.watermark.set(
            this.$refs.idm_page_root,
            propData.watermarkZindex,
            propData.watermarkType != "font" ? propData.watermarkImg : _watermarkFont,
            propData.watermarkType == "image" ? "" : _watermarkFont1,
            {
              fontColor:
                propData.watermarkColor &&
                IDM.hex8ToRgbaString(propData.watermarkColor.hex8),
              fontSize: `${propData.watermarkFontSize}px`,
              width: propData.watermarkSize,
              height: propData.watermarkSize,
              rotate: propData.watermarkRotate,
              imgSize: propData.watermarkImgSize,
              imgLeftSize: propData.watermarkImgLeftSize,
              fontLeftSize: propData.watermarkFontLeftSize,
              opacity: propData.watermarkOpacity / 100,
              topSize: propData.watermarkTopSize,
            }
          );
        } else {
          IDM.watermark.close(this.$refs.idm_page_root);
        }
      });
      IDM.setStyleToPageHead(
        "PAGE_" + this.PageSettingData.id + "_" + this.routerId,
        styleObject
      );
      //加载外部js和css
      if (propData.resourceList && propData.resourceList.length > 0) {
        propData.resourceList.forEach((item) => {
          if (item.resourceType == "js") {
            IDM.module.loadJs(
              IDM.url.getWebPath(item.resourceUrl),
              true,
              function () {},
              { async: item.async, defer: item.defer }
            );
          } else {
            IDM.module.loadCss(
              IDM.url.getWebPath(item.resourceUrl),
              true,
              function () {}
            );
          }
        });
      }
      this.convertThemeListAttrToStyleObject(propData);
    },

    /**
     * 主题颜色
     */
    convertThemeListAttrToStyleObject(propData) {
      var themeList = propData.themeList;
      if (!themeList) {
        return;
      }
      const themeNamePrefix =
        IDM.setting &&
        IDM.setting.applications &&
        IDM.setting.applications.themeNamePrefix
          ? IDM.setting.applications.themeNamePrefix
          : "idm-theme-";
      for (var i = 0; i < themeList.length; i++) {
        var item = themeList[i];
        //item.key：为主题样式的key
        //item.mainColor：主要颜色值
        //item.minorColor：次要颜色值
        if (item.key != IDM.theme.getCurrentThemeInfo()) {
          //此处比对是不渲染输出不用的样式，如果页面会刷新就可以把此处放开
          continue;
        }
        let cssObject_color_main = {
          color: item.mainColor ? item.mainColor.hex8 + " !important" : "",
        };
        let cssObject_border_main = {
          "border-color": item.mainColor ? item.mainColor.hex8 : "",
        };
        let cssObject_background_main = {
          "background-color": item.mainColor ? item.mainColor.hex8 : "",
        };
        let cssObject_color_minor = {
          color: item.minorColor ? item.minorColor.hex8 : "",
        };
        let cssObject_border_minor = {
          "border-color": item.minorColor ? item.minorColor.hex8 : "",
        };
        let cssObject_background_minor = {
          "background-color": item.minorColor ? item.minorColor.hex8 : "",
        };
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm_module_user_defined`,
          {
            ...cssObject_border_main,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm_module_user_defined>div`,
          {
            ...cssObject_background_main,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .user-defined-logo-svg,
          .${
            themeNamePrefix + item.key
          } .idm_page_user_defined_leftbar svg.user-defined-add-svg,
          .${
            themeNamePrefix + item.key
          } .idm_page_user_defined_modal_moduleitem .user-defined-modal-changeseats,
          .${
            themeNamePrefix + item.key
          } .idm_page_user_defined_modal_moduleitem .user-defined-modal-replace`,
          {
            ...cssObject_color_main,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm-ant-btn:active,
          .${themeNamePrefix + item.key} .idm-ant-btn.active,
          .${themeNamePrefix + item.key} .idm-ant-btn-dashed:active,
          .${themeNamePrefix + item.key} .idm-ant-btn-dashed.active`,
          {
            ...cssObject_color_main,
            ...cssObject_border_main,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm-ant-btn-primary,
          .${themeNamePrefix + item.key} .idm-ant-btn-primary:hover,
          .${themeNamePrefix + item.key} .idm-ant-btn-primary:focus`,
          {
            ...cssObject_background_main,
            ...cssObject_border_main,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm-ant-btn:hover,
          .${themeNamePrefix + item.key} .idm-ant-btn:focus,
          .${themeNamePrefix + item.key} .idm-ant-btn-dashed:hover,
          .${themeNamePrefix + item.key} .idm-ant-btn-dashed:focus`,
          {
            ...cssObject_color_minor,
            ...cssObject_border_minor,
          }
        );
        IDM.setStyleToPageHead(
          `.${themeNamePrefix + item.key} .idm-ant-btn-primary:hover,
          .${themeNamePrefix + item.key} .idm-ant-btn-primary:focus`,
          {
            color: "#FFFFFF",
            ...cssObject_background_minor,
            ...cssObject_border_minor,
          }
        );
      }
    },
    /**
     * 渲染加载指定ID的窗口
     * 首先取出对应的数据，判断是否
     */
    renderDialog(moduleId) {
      const opModule = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        moduleId
      );
      if (!opModule) {
        return false;
      }
      if (opModule.renderType == "firstrender" || opModule.renderType == "activerender") {
        opModule.renderLicence = true;
        if (opModule.renderType == "firstrender" && opModule.loaded) {
          return _.cloneDeep(opModule);
        } else {
          //实时渲染加载之前要把页面组件加载状态设置为false，否则实时渲染的组件消息通信无法准确接收到消息，需要等全部加载完再接收消息
          this.IDM.broadcast.pageModuleLoadCompleteBefore(this.routerId);
          //修改成全部未加载
          this.resetLayoutInnerModuleLoadedStatus(opModule);
          this.initModuleTreeToPage(opModule);
        }
      }
      return _.cloneDeep(opModule);
    },
    setShowDialog(dialogObject) {
      this.dialogObjectList.push(dialogObject);
      $("#router_page_" + this.routerId + " #" + dialogObject.packageid).css(
        "display",
        "flex"
      );
      this.dialogVisibleStatus = true;
      this.dialogIsHideing = false;
    },
    /**
     * 关闭当前打开的窗口
     */
    closeThisOpenDialog(ctx) {
      var customParam = ctx.customParam ? ctx.customParam : ctx;
      var moduleIdArray = [];
      customParam.targetModule.forEach((item) => {
        moduleIdArray.push(item.moduleId);
        this.dialogObjectList.forEach((ditem, dindex) => {
          if (ditem.packageid == item.moduleId) {
            ditem.dialogIsHideing = true;
            $(
              "#router_page_" +
                this.routerId +
                " .idm_dialog_shade_layer_" +
                item.moduleId
            ).attr("hideing", "hideing");
            if (ditem.layerOption) {
              ditem.layerOption.cancel && ditem.layerOption.cancel(ditem);
            }
            //如果是确认按钮调用的关闭则去调用yes方法
            if (ctx.isOkEvent) {
              ditem.layerOption && ditem.layerOption.yes && ditem.layerOption.yes(ditem);
            }
          }
        });
      });
      if (this.dialogObjectList.length <= moduleIdArray.length) {
        this.dialogIsHideing = true;
      }
      let that = this;
      that.sendBroadcastMessage({
        type: "linkageCloseDialog",
        message: ctx,
        rangeModule: moduleIdArray,
      });
      setTimeout(() => {
        customParam.targetModule.forEach((item) => {
          $("#router_page_" + this.routerId + " #" + item.moduleId).css(
            "display",
            "none"
          );
          that.destroyDialog(item.moduleId);
          //从dialogObjectList中删除
          if (that.dialogObjectList.length == 1) {
            that.dialogObjectList = [];
            return;
          }
          let existsIndex = -1;
          that.dialogObjectList.forEach((ditem, dindex) => {
            if (ditem.packageid == item.moduleId) {
              existsIndex = dindex;
              if (ditem.layerOption) {
                ditem.layerOption.end && ditem.layerOption.end(ditem);
              }
            }
          });
          if (existsIndex > -1) {
            //存在就清除
            that.dialogObjectList.splice(existsIndex, 1);
          }
        });
        if (that.dialogObjectList.length == 0) {
          that.dialogVisibleStatus = false;
          that.dialogIsHideing = false;
        }
      }, 500);
      if (ctx.callback) {
        ctx.callback();
      }
    },
    /**
     * 销毁指定ID的窗口
     */
    destroyDialog(moduleId) {
      const opModule = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        moduleId
      );
      if (opModule && opModule.renderType == "activerender") {
        $("#router_page_" + this.routerId + " #" + moduleId).remove();
      }
    },
    /**
     * 显示未加载的隐藏的组件
     * @param {*} moduleIdList
     */
    showHideNoLoadModule(moduleIdList) {
      this.resetLayoutInnerModuleLoadedStatus(
        this.PageSettingData.page.layout.children,
        moduleIdList
      );
      this.initModuleTreeToPage();
    },
    /**
     * 加载组件的自定义函数脚本
     * @param {*} module
     */
    initModulePropCustomBuildCode(module) {
      //追加js脚本
      if (module && module.props) {
        const oldScript = $("#customFun_" + module.packageid);
        var moduleScriptDom = oldScript.length
          ? oldScript
          : $('<script type="text/javascript" id="customFun_' + module.packageid + '"/>');
        let functionList = [];
        this.initModulePropCustomBuildCodeRecursive(module.props, functionList);
        if (functionList.length) {
          var scriptArray = [];
          functionList.forEach((item) => {
            scriptArray.push(`window.${item.name}=${item.customBuildCode}`);
          });
          $("body").append(moduleScriptDom.html(scriptArray.join(";")));
        } else {
          moduleScriptDom.remove();
        }
      }
    },
    initModulePropCustomBuildCodeRecursive(attrObject, functionList) {
      if (IDM.type(attrObject) === "array") {
        //是数组，则查找子级是否包含customBuildCode、customSourceCode、name【IdmAutoGenFun_开头】、idmBuiltin=false的
        for (let index = 0; index < attrObject.length; index++) {
          const item = attrObject[index];
          if (
            item.customBuildCode &&
            item.customSourceCode &&
            item.name &&
            item.idmBuiltin === false &&
            item.name.startsWiths("IdmAutoGenFun_") &&
            IDM.type(item.customBuildCode) === "string" &&
            IDM.type(item.customSourceCode) === "string"
          ) {
            functionList.push(_.cloneDeep(item));
          } else {
            this.initModulePropCustomBuildCodeRecursive(item, functionList);
          }
        }
      } else if (IDM.type(attrObject) === "object") {
        Object.keys(attrObject).forEach((key) => {
          this.initModulePropCustomBuildCodeRecursive(attrObject[key], functionList);
        });
      }
    },

    /**
     * 加载组件的自定义样式代码
     * @param {*} module
     */
    initModulePropCustomBuildStyle(module) {
      //追加js脚本
      if (module && module.props) {
        this.initModulePropCustomBuildStyleRecursive(module.props, module);
      }
    },
    initModulePropCustomBuildStyleRecursive(attrObject, module) {
      if (IDM.type(attrObject) === "array") {
        let paramCom = {
          pageId: this.pageid,
          routerId: this.routerId,
          moduleObject: module,
          ...this.pageInterfaceResultObject,
        };
        //是数组，则查找子级是否包含styleUUID、styleType、cssCode、idmCoreLoad=true的
        for (let index = 0; index < attrObject.length; index++) {
          const item = attrObject[index];
          if (
            item.styleUUID &&
            item.styleType &&
            item.cssCode &&
            item.idmCoreLoad === true &&
            IDM.type(item.cssCode) === "string"
          ) {
            //进行表达式转换
            if (
              !item.styleCondition ||
              (item.styleCondition && IDM.getExpressData(item.styleCondition, paramCom))
            ) {
              let newUUID =
                item.styleUUID + "_" + item.styleRenderUUID
                  ? IDM.getExpressData(item.styleRenderUUID, paramCom, "", false)
                  : IDM.uuid();
              IDM.setStyleHtmlToPageHead(
                newUUID,
                IDM.getExpressData(item.cssCode, paramCom, "", false)
              );
            }
          } else {
            this.initModulePropCustomBuildStyleRecursive(item, module);
          }
        }
      } else if (IDM.type(attrObject) === "object") {
        Object.keys(attrObject).forEach((key) => {
          this.initModulePropCustomBuildStyleRecursive(attrObject[key], module);
        });
      }
    },
    /**
     * 加载组件树到页面中，递归逐级加载
     * moduleData：要渲染的组件数据树结构
     * ischildren：是否为子组件数据
     * fModule：子组件所在的父级容器组件
     * addNextForModulePackageid：要追加到哪个组件的下面（非子级）的packageid
     */
    initModuleTreeToPage(moduleData, ischildren, fModule, addNextForModulePackageid) {
      let that = this;
      moduleData = moduleData || that.PageSettingData.page.layout.children;
      if (!(moduleData instanceof Array)) {
        moduleData = [moduleData];
      }
      //循环取出当前一级未加载的组件
      var loadModule, beforeModule, laterModule;
      moduleData.forEach((item, index) => {
        if (item.comType == "dialog" && item.renderLicence !== true) {
          //查找props
          /*for (let index = 0; index < that.PageSettingData.page.componentsMap.length; index++) {
            const pitem = that.PageSettingData.page.componentsMap[index];
            if (pitem.packageid == item.packageid) {
              item.props = pitem.props;
            }
          }*/
          let dialogRenderType = item.props.compositeAttr.dialogRenderType;
          //beforehand：不用判断直接放行可以进行渲染  firstrender：按需首次渲染  activerender：激活时渲染
          item.renderType = dialogRenderType;
          //renderLicence：渲染许可，true表示可以进行渲染，false表示暂时不渲染跳过
          item.renderLicence = !(
            dialogRenderType == "firstrender" || dialogRenderType == "activerender"
          );
          if (!item.renderLicence) {
            return;
          }
        }
        if (!item.hasLoading && !loadModule) {
          item.hasLoading = true;
          item.loading = true;

          //查找props覆盖树结构中的
          /*
          for (let index = 0; index < that.PageSettingData.page.componentsMap.length; index++) {
            const sitem = that.PageSettingData.page.componentsMap[index];
            if (sitem.packageid == item.packageid) {
              item.props = sitem.props;
            }
          }*/
          loadModule = item;
          //此处要判断一下openAuthorize&&privilege&&role&&dept&&user
          let attrConfig = IDM.setting.applications.basicAttributeAuthorizeConfig;
          let openAuthorize = attrConfig.openAuthorize;
          if (
            (item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.showType == "show") ||
            (item.againLoad === true &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.showType != "role")
          ) {
            console.log(
              "🚀 ~ file: Page.vue ~ line 1888 ~ moduleData.forEach ~ item.againLoad",
              item.againLoad
            );
            //这里就是直接显示，不做处理
          } else if (
            item.props &&
            item.props.basicAttr &&
            item.props.basicAttr.showType == "hide"
          ) {
            if (item.props.basicAttr.hideType == "load") {
              //加载不显示
              loadModule.loadAndHide = true;
            } else {
              loadModule = null;
            }
            item.loaded = true;
          } else if (
            item.props &&
            item.props.basicAttr &&
            item.props.basicAttr.showType == "custom"
          ) {
            //自定义显示
            let isShowComponent = that.commonCustomEventFunHandle(
              item.props.basicAttr,
              "customShowEvent",
              this.pageInterfaceResultObject
            );
            if (!isShowComponent) {
              loadModule = null;
              item.loaded = true;
            }
          } else if (openAuthorize === true) {
            let privilege = attrConfig.privilege || {},
              privilegePass = -1,
              role = attrConfig.role || {},
              rolePass = -1,
              dept = attrConfig.dept || {},
              deptPass = -1,
              user = attrConfig.user || {},
              userPass = -1;
            //比对权限
            if (
              privilege.open === true &&
              privilege.comparisonObject &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.privilegeList &&
              item.props.basicAttr.privilegeList.length
            ) {
              let privilegeComparisonObject = IDM.express.replace(
                "@[" + privilege.comparisonObject + "]",
                { IDM: IDM, window, ...this.pageInterfaceResultObject }
              );
              if (privilege.separator && IDM.type(privilegeComparisonObject) != "array") {
                privilegeComparisonObject = privilegeComparisonObject.split(
                  privilege.separator
                );
              }
              //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
              privilegePass = false;
              //直接用选择的权限去判断
              item.props.basicAttr.privilegeList.forEach((iitem) => {
                let comparisonKey = IDM.express.replace(
                  "@[" + (privilege.comparisonKey || "key") + "]",
                  iitem
                );
                if (
                  privilegeComparisonObject === undefined ||
                  privilegeComparisonObject.indexOf(comparisonKey) > -1
                ) {
                  privilegePass = true;
                }
              });
            }
            //比对角色
            if (
              role.open === true &&
              role.comparisonObject &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.roleList &&
              item.props.basicAttr.roleList.length
            ) {
              let roleComparisonObject = IDM.express.replace(
                "@[" + role.comparisonObject + "]",
                { IDM: IDM, window, ...this.pageInterfaceResultObject }
              );
              if (role.separator && IDM.type(roleComparisonObject) != "array") {
                roleComparisonObject = roleComparisonObject.split(role.separator);
              }
              //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
              rolePass = false;
              //直接用选择的权限去判断
              item.props.basicAttr.roleList.forEach((iitem) => {
                let comparisonKey = IDM.express.replace(
                  "@[" + (role.comparisonKey || "key") + "]",
                  iitem
                );
                if (
                  roleComparisonObject === undefined ||
                  roleComparisonObject.indexOf(comparisonKey) > -1
                ) {
                  rolePass = true;
                }
              });
            }
            //比对部门
            if (
              dept.open === true &&
              dept.comparisonObject &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.deptList &&
              item.props.basicAttr.deptList.length
            ) {
              let deptComparisonObject = IDM.express.replace(
                "@[" + dept.comparisonObject + "]",
                { IDM: IDM, window, ...this.pageInterfaceResultObject }
              );
              if (dept.separator && IDM.type(deptComparisonObject) != "array") {
                deptComparisonObject = deptComparisonObject.split(dept.separator);
              }
              //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
              deptPass = false;
              //直接用选择的权限去判断
              item.props.basicAttr.deptList.forEach((iitem) => {
                let comparisonKey = IDM.express.replace(
                  "@[" + (dept.comparisonKey || "key") + "]",
                  iitem
                );
                if (
                  deptComparisonObject === undefined ||
                  deptComparisonObject.indexOf(comparisonKey) > -1
                ) {
                  deptPass = true;
                }
              });
            }
            //对比部门集合（包含贯穿下级的）
            if (
              dept.open === true &&
              dept.comparisonObject &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.deptColumns &&
              item.props.basicAttr.deptColumns.length
            ) {
              let deptComparisonObject = IDM.express.replace(
                "@[" + dept.comparisonObject + "]",
                { IDM: IDM, window, ...this.pageInterfaceResultObject }
              );
              if (dept.separator && IDM.type(deptComparisonObject) != "array") {
                deptComparisonObject = deptComparisonObject.split(dept.separator);
              }
              //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
              deptPass = false;
              if (deptComparisonObject === undefined) {
                deptPass = true;
              } else {
                //直接用选择的权限去判断
                item.props.basicAttr.deptColumns.forEach((iitem) => {
                  //对比，如果不包含下级则只对比最后一个，如果包含下级则只要对比出来了则算通过
                  let deptList = iitem.deptList,
                    includeChild = iitem.includeChild;
                  deptList &&
                    deptList.forEach((deptItem) => {
                      let comparisonKey = IDM.express.replace(
                        "@[" + (dept.comparisonKey || "key") + "]",
                        deptItem
                      );
                      if (
                        (includeChild == "0" &&
                          IDM.type(deptComparisonObject) == "array" &&
                          deptComparisonObject[deptComparisonObject.length - 1] ==
                            comparisonKey) ||
                        (includeChild == "1" &&
                          deptComparisonObject.indexOf(comparisonKey) > -1)
                      ) {
                        deptPass = true;
                      }
                    });
                });
              }
            }
            //比对用户
            if (
              user.open === true &&
              user.comparisonObject &&
              item.props &&
              item.props.basicAttr &&
              item.props.basicAttr.userList &&
              item.props.basicAttr.userList.length
            ) {
              let userComparisonObject = IDM.express.replace(
                "@[" + user.comparisonObject + "]",
                { IDM: IDM, window, ...this.pageInterfaceResultObject }
              );
              //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
              userPass = false;
              //直接用选择的权限去判断
              let userArray = item.props.basicAttr.userList.map((item) => {
                let comparisonKey = IDM.express.replace(
                  "@[" + (user.comparisonKey || "key") + "]",
                  item
                );
                return comparisonKey;
              });
              if (userArray.indexOf(userComparisonObject) > -1) {
                userPass = true;
              }
            }
            //如果不为空则需要判断是否通过
            if (
              !(
                (privilegePass === -1 &&
                  rolePass === -1 &&
                  deptPass === -1 &&
                  userPass === -1) ||
                (privilegePass !== -1 && privilegePass) ||
                (rolePass !== -1 && rolePass) ||
                (deptPass !== -1 && deptPass) ||
                (userPass !== -1 && userPass)
              )
            ) {
              loadModule = null;
              item.loaded = true;
            }
          }
          if (loadModule) {
            //如果不为空，则取出下一个非弹窗组件
            for (let i = 0; i < moduleData.length; i++) {
              if (moduleData[i].comType != "dialog" && index > i) {
                beforeModule = moduleData[i];
              } else if (index < i && moduleData[i].comType != "dialog" && !laterModule) {
                laterModule = moduleData[i];
              }
              if (beforeModule && laterModule) {
                break;
              }
            }
          }
        }
      });
      if (!loadModule) {
        //一级没有待加载的，再去加载子级
        moduleData.forEach((item) => {
          if (item.comType == "dialog" && !item.renderLicence) {
            //渲染许可为false跳过不渲染下面的子级
            return;
          }
          if (item.loaded && item.children && item.children.length > 0) {
            that.initModuleTreeToPage(item.children, true, item);
          }
        });
        //判断是否加载完成，如果加载完成需要去调用统一接口并设置页面加载已完成，否则组件通信用不了
        if (loadModule == null && this.pageModuleDataIsLoaded(null, true, "loaded")) {
          this.requestPageCommonInterfaceData(true);
        }
      } else {
        this.initModulePropCustomBuildCode(loadModule);
        //加载组件样式，样式内部支持使用页面接口返回的数据
        this.initModulePropCustomBuildStyle(loadModule);
        //追加容器
        let comObject = loadModule;
        comObject.mountComplete = this.moduleMountComplete;
        comObject.moduleReload = this.moduleReload;
        comObject.dynamicRenderModuleGroupInitData = this.dynamicRenderModuleGroupInitData;
        comObject.removeDynamicRenderModuleGroup = this.removeDynamicRenderModuleGroup;
        comObject.getModuleChildrenPackageId = this.getModuleChildrenPackageId;
        //追加div
        let newComDiv = that.createModuleDom(comObject);
        let containerId = "";
        if (comObject.comType == "dialog") {
          containerId = that.PageSettingData.id;
          $("#idm_dialog_wrap_" + that.routerId).append(newComDiv);
        } else if (
          comObject.positionMode == "absolute" &&
          (!ischildren || (ischildren && fModule && fModule.comId == "0"))
        ) {
          containerId = that.PageSettingData.id;
          $("#idm_hover_layer_wrap").append(newComDiv);
          this.addModuleEndpoint(comObject);
        } else if (addNextForModulePackageid) {
          //添加到下方
          containerId = addNextForModulePackageid;
          $("#router_page_" + that.routerId + " #" + containerId).after(newComDiv);
        } else if (ischildren && fModule) {
          containerId = fModule.packageid;
          if (containerId == that.PageSettingData.id) {
            $("#PAGE_" + containerId + "_" + that.routerId).append(newComDiv);
          } else {
            var containerDom = $("#router_page_" + that.routerId + " #" + containerId);
            containerDom.removeClass("drag_container_empty");
            var containerInnerDom = containerDom.find(">*[idm-ctrl]");
            // containerInnerDom.show();
            if (comObject.containerIndex || comObject.containerIndex == "0") {
              //添加内部容器，同时要删除drag_container_empty
              var innercontainer = containerInnerDom.find(
                ".drag_container[idm-ctrl-id='" +
                  fModule.id +
                  "'][idm-container-index=" +
                  comObject.containerIndex +
                  "]"
              );
              innercontainer && innercontainer.append(newComDiv);
              innercontainer && innercontainer.removeClass("drag_container_empty");
              //找不到容器，继续加载后续的
              if (!innercontainer || (innercontainer && innercontainer.length == 0)) {
                //loadModule.loaded = true;
                //设置为无载体容器
                loadModule.nocontainer = true;
                that.initModuleTreeToPage();
                //判断如果加载完成则需要调用后续的接口
                if (that.pageModuleDataIsLoaded(null, true)) {
                  that.requestPageCommonInterfaceData(true);
                }
                return;
              }
            } else {
              if (
                beforeModule &&
                containerInnerDom.find("#" + beforeModule.packageid).length
              ) {
                containerInnerDom.find("#" + beforeModule.packageid).after(newComDiv);
              } else if (
                laterModule &&
                containerInnerDom.find("#" + laterModule.packageid).length
              ) {
                containerInnerDom.find("#" + laterModule.packageid).before(newComDiv);
              } else {
                containerInnerDom.append(newComDiv);
              }
            }
          }
        } else if (!fModule) {
          //此处只适合一级显示隐藏的加载 判断上一个，上一个没有在取下一个
          if (beforeModule) {
            $("#router_page_" + that.routerId + " #" + beforeModule.packageid).after(
              newComDiv
            );
          } else if (laterModule) {
            $("#router_page_" + that.routerId + " #" + laterModule.packageid).before(
              newComDiv
            );
          }
        }
        //这里要做渲染，根据relationId: "component_o0mOWZACB0IVR5hz"   relationType: "top"
        //关联ID
        comObject.env = "production";
        //追加路由ID，页面ID
        comObject.routerId = this.routerId;
        comObject.pageid = this.pageid;
        if (comObject.comType == "svg") {
          //直接加载回调
          that.moduleMountComplete(comObject);
        } else {
          that.IDM.module.addModuleToQueue(comObject);
        }
      }

      return loadModule;
    },
    /**
     * 判断是否加载完成,未完成返回false，主要用于拷贝的时候递归加载完成的判断
     * loadType:加载类型：loaded 是否全部加载完成、loading：加载中的、hasLoading：已经开始加载的
     * waitRemoveModuleId：等待删除已加载的组件ID数组
     */
    pageModuleDataIsLoaded(
      moduleData,
      isnotloadinner,
      loadType = "hasLoading",
      waitRemoveModuleId
    ) {
      let that = this;
      var isLoaded = true;
      moduleData = moduleData || that.PageSettingData.page.layout.children;
      if (!(moduleData instanceof Array)) {
        moduleData = [moduleData];
      }
      moduleData.forEach((item) => {
        if (item.comType == "dialog" && !item.renderLicence) {
          //渲染许可为false跳过不渲染下面的子级
          return;
        }
        //无载体的组件也要设置为已加载完成
        if (!item[loadType] && item.nocontainer !== true) {
          isLoaded = false;
          // if(isnotloadinner&&(item.containerIndex||item.containerIndex=="0")){
          //   isLoaded = true;
          // }
        }
        if (item[loadType]) {
          //已经渲染的，可移除
          waitRemoveModuleId &&
            _.remove(waitRemoveModuleId, function (n) {
              return n == item.packageid;
            });
        }
      });
      if (isLoaded) {
        moduleData.forEach((item) => {
          if (item.comType == "dialog" && !item.renderLicence) {
            //渲染许可为false跳过不渲染下面的子级
            return;
          }
          if (item.children && item.children.length > 0 && isLoaded) {
            isLoaded = this.pageModuleDataIsLoaded(
              item.children,
              isnotloadinner,
              loadType,
              waitRemoveModuleId
            );
          }
        });
      }
      return isLoaded;
    },
    /**
     * 创建组件dom外部元素
     */
    createModuleDom(comObject) {
      let that = this;
      //包裹最外层的ID
      comObject.packageid = comObject.packageid || "component_" + IDM.UUID();
      //组件内部ID，这里可能不受核心框架控制，需要谨慎使用
      comObject.id = comObject.id || comObject.packageid + "_inner";
      //追加div
      var newComDiv = $("<div />");
      //追加设置属性
      newComDiv.attr("id", comObject.packageid);
      newComDiv.attr("idm-com-anchor-id", comObject.packageid);
      newComDiv.attr("idm-com-id", comObject.comId);
      newComDiv.attr("idm-com-classid", comObject.classId);
      newComDiv.attr("idm-com-classname", comObject.className);
      if (comObject.loadAndHide) {
        newComDiv.attr("style", "display:none");
      }
      //追加组件标识
      newComDiv.addClass("idm_module");
      newComDiv.addClass(comObject.packageid);
      let innerDom = $("<div />").attr("id", "idm_" + comObject.id + this.routerId);
      //如果是svg是没有第三方组件包的
      if (comObject.comType == "svg" && comObject.svgData) {
        innerDom.append(comObject.svgData);
        //根据属性注册是件，复制其他属性
        that.svgComponentPropsHandle(innerDom, comObject);
      }
      //追加内部div，提供给组件加载使用，只有ID，后续将不会再使用
      newComDiv.append(innerDom);
      if (comObject.positionMode == "absolute") {
        that.createHoverLayoutHandle(newComDiv, comObject);
      }
      return newComDiv;
    },
    /**
     * 创建悬浮模式下的组件dom外部元素
     */
    createHoverLayoutHandle(newComDiv, comObject) {
      let that = this;
      //绝对定位追加宽高和坐标 追加可拖拽的手势
      newComDiv.addClass("idm_module_absolute");
      this.resetHoverModuleStyleInfo(newComDiv, comObject);
      //这里可以继续处理内置的组件事件，比如svg绘制的
    },
    /**
     * 重绘样式
     * @param {*} moduleDOM
     * @param {*} currentModule
     */
    resetHoverModuleStyleInfo(moduleDOM, currentModule) {
      let that = this;
      let _basicAttr =
        currentModule.props && currentModule.props.basicAttr
          ? currentModule.props && currentModule.props.basicAttr
          : {};
      //获取方位、坐标、宽高
      const modulePositionOrigin = _basicAttr.positionOrigin || "leftTop";
      let moduleCurrentWH =
        _basicAttr.positionWH ||
        `${that.defaultModuleSize.width}.${that.defaultModuleSize.height}`;
      moduleCurrentWH = moduleCurrentWH.split(",");
      let moduleCurrentW =
          moduleCurrentWH.length > 0 ? parseFloat(moduleCurrentWH[0]) : 0,
        moduleCurrentH = moduleCurrentWH.length > 1 ? parseFloat(moduleCurrentWH[1]) : 0;
      let moduleCurrentXY = _basicAttr.positionXY || "0,0";
      moduleCurrentXY = moduleCurrentXY.split(",");
      let moduleCurrentX =
          moduleCurrentXY.length > 0 ? parseFloat(moduleCurrentXY[0]) : 0,
        moduleCurrentY = moduleCurrentXY.length > 1 ? parseFloat(moduleCurrentXY[1]) : 0;

      //获取索引
      let moduleZindex = _basicAttr.zIndex || 0;
      let moduleOpacity = _basicAttr.opacity == 0 ? 0 : _basicAttr.opacity || 100;
      let moduleScale = _basicAttr.scale || 1;
      let moduleRotateX = _basicAttr.rotateX || 0;
      let moduleRotateY = _basicAttr.rotateY || 0;
      let moduleRotateZ = _basicAttr.rotateZ || 0;

      let styleObject = {};
      switch (modulePositionOrigin) {
        case "leftTop":
          styleObject = {
            left: moduleCurrentX + "px",
            top: moduleCurrentY + "px",
            right: "auto",
            bottom: "auto",
            width: moduleCurrentW + "px",
            height: moduleCurrentH + "px",
          };
          break;
        case "rightTop":
          styleObject = {
            left: "auto",
            top: moduleCurrentY + "px",
            right: moduleCurrentX + "px",
            bottom: "auto",
            width: moduleCurrentW + "px",
            height: moduleCurrentH + "px",
          };
          break;
        case "rightBottom":
          styleObject = {
            left: "auto",
            top: "auto",
            right: moduleCurrentX + "px",
            bottom: moduleCurrentY + "px",
            width: moduleCurrentW + "px",
            height: moduleCurrentH + "px",
          };
          break;
        case "leftBottom":
          styleObject = {
            left: moduleCurrentX + "px",
            top: "auto",
            right: "auto",
            bottom: moduleCurrentY + "px",
            width: moduleCurrentW + "px",
            height: moduleCurrentH + "px",
          };
          break;
      }
      if (_basicAttr.positionType == "fixed") {
        styleObject["position"] = "fixed";
      }
      styleObject["z-index"] = moduleZindex;
      styleObject["opacity"] = moduleOpacity / 100;
      styleObject[
        "transform"
      ] = `scale(${moduleScale}) rotateX(${moduleRotateX}deg) rotateY(${moduleRotateY}deg) rotateZ(${moduleRotateZ}deg)`;
      moduleDOM && moduleDOM.css(styleObject);
    },
    /**
     * 获取指定层级的组件树结构数据
     */
    getModuleTree(module, packageid) {
      if (!(module instanceof Array)) {
        module = [module];
      }
      var _findModule;
      module.forEach((item) => {
        if (item.packageid == packageid) {
          _findModule = item;
        } else if (!_findModule && item.children) {
          _findModule = this.getModuleTree(item.children, packageid);
        }
      });
      return _findModule;
    },
    /**
     * 获取组件的子组件packageid集合，返回数组
     * @param {*} packageid 父组件packageid
     * @param {*} idmContainerId 要获取所在容器的containerIndex，如果为空则获取所有的
     * @param {*} containerGroup 是否容器分组，如果是则containerIndex需要用 idmContainerId+"_" 前缀这种方式查找
     */
    getModuleChildrenPackageId(packageid, idmContainerId, containerGroup) {
      let allChildrenPackageIdArray = [];
      const filterModuleTree = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        packageid
      );
      if (!filterModuleTree || filterModuleTree?.children?.length == 0) {
        return allChildrenPackageIdArray;
      }
      let existsRenderModule = filterModuleTree.children.filter(
        (item) =>
          item.containerIndex == idmContainerId ||
          (containerGroup && item.containerIndex.startsWiths(idmContainerId + "_"))
      );

      this.findTreeAllModulePackageId(existsRenderModule, allChildrenPackageIdArray);

      return allChildrenPackageIdArray;
    },
    /**
     * 动态渲染复制组件组的组件且加载数据，每次只复制一个分组(只有不包含的dynamicModule)
     * 动态渲染需要移除之前的重新渲染一遍。
     * @param {*} packageid 组件packageid，要动态渲染复制的父级组件
     * @param {*} idmContainerId 要动态渲染的容器索引ID
     * @param {*} itemData 动态渲染组件所使用到的数据
     * @param {*} containerGroup 是否容器分组，如果是则containerIndex需要用 idmContainerId+"_" 前缀这种方式查找
     * @param {*} sendMessageKey 发送联动消息的messageKey标识，为空则默认为dynamicRenderModule
     */
    dynamicRenderModuleGroupInitData(
      packageid,
      idmContainerId,
      itemData,
      containerGroup,
      sendMessageKey
    ) {
      debugger;
      //根据packageid找出该组件下的所有组件进行复制（支持树结构式组件），复制完成后然后把数据以组件通信的消息方式发送给对应复制后的组件
      const copyModuleTree = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        packageid
      );
      if (
        !copyModuleTree ||
        (copyModuleTree && !copyModuleTree.children) ||
        (copyModuleTree && copyModuleTree.children && copyModuleTree.children.length == 0)
      ) {
        return;
      }
      //先查找idmContainerId是否存在
      let existsRenderModule = copyModuleTree.children.filter(
        (item) =>
          item.containerIndex == idmContainerId ||
          (containerGroup && item.containerIndex.startsWiths(idmContainerId + "_"))
      );

      if (existsRenderModule && existsRenderModule.length) {
        //只移除dom，不移除数据
        existsRenderModule.forEach((item) => {
          $("#router_page_" + this.routerId + " #" + item.packageid).remove();
        });
        let allModulePackageId = [];
        this.findTreeAllModulePackageId(existsRenderModule, allModulePackageId, true);
        //把当前的参数存储到待消费变量中，等待组件加载的时候去判断
        this.dynamicWaitExpendObject.push({
          packageid,
          allModulePackageId,
          idmContainerId,
          itemData,
          sendMessageKey,
        });
        //删除全部加载状态
        this.resetLayoutInnerModuleLoadedStatus(existsRenderModule);

        //调用重新加载
        this.initModuleTreeToPage(existsRenderModule, true, copyModuleTree, false);
        return;
      }

      let copyModuleArray = _.cloneDeep(
        copyModuleTree.children.filter((item) => !item.dynamicModule)
      );
      //发现如果没有则随机取一批复制
      if (!copyModuleArray || (copyModuleArray && copyModuleArray.length == 0)) {
        let firstContainerId = copyModuleTree.children[0].containerIndex;
        if (containerGroup) {
          let oiArray = firstContainerId.split("_");
          if (oiArray.length > 1) {
            oiArray.splice(oiArray.length - 1, 1);
          }
          firstContainerId = oiArray.join("_");
        }
        copyModuleArray = _.cloneDeep(
          copyModuleTree.children.filter(
            (item) =>
              item.containerIndex == firstContainerId ||
              (containerGroup && item.containerIndex.startsWiths(firstContainerId + "_"))
          )
        );
      }

      //更换containerIndex
      copyModuleArray.forEach((item) => {
        const ciArray = item.containerIndex.split("_");
        if (containerGroup && ciArray.length > 1) {
          item.containerIndex = idmContainerId + "_" + ciArray[ciArray.length - 1];
        } else {
          item.containerIndex = idmContainerId;
        }
      });

      let allModulePackageId = [];
      //重新刷新所有的id并且赋值dynamicModule=true且从map中拷贝一份
      this.refreshTreeModulePrimaryKey(
        copyModuleArray,
        allModulePackageId,
        idmContainerId,
        containerGroup
      );
      this.refreshModuleAndMapGlobalId(copyModuleArray, copyModuleTree);

      //把当前的参数存储到待消费变量中，等待组件加载的时候去判断
      this.dynamicWaitExpendObject.push({
        packageid,
        allModulePackageId,
        idmContainerId,
        itemData,
        sendMessageKey,
      });

      //合并数组
      copyModuleTree.children.push.apply(copyModuleTree.children, copyModuleArray);

      //删除全部加载状态
      this.resetLayoutInnerModuleLoadedStatus(copyModuleArray);

      //调用重新加载
      this.initModuleTreeToPage(copyModuleArray, true, copyModuleTree, false);
      console.log(this.PageSettingData);
    },
    /**
     * 移除动态渲染的组件组
     * 如果删除的是原始组件需要找其中一条修改为原始组件，如果是只有一个索引了则不移除数据只移除dom
     * @param {*} packageid  组件packageid，动态渲染复制的父级组件
     * @param {*} idmContainerId 动态渲染的容器索引ID
     * @param {*} containerGroup 是否容器分组，如果是则containerIndex需要用 idmContainerId+"_" 前缀这种方式查找
     */
    removeDynamicRenderModuleGroup(packageid, idmContainerId, containerGroup) {
      const copyModuleTree = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        packageid
      );
      //查找containerIndex的数量(不包含原始)和原始的containerIndex
      let containerIndexArray = [],
        originalIndex = "";
      copyModuleTree.children &&
        copyModuleTree.children.forEach((item) => {
          let newContainerIndex = item.containerIndex;
          if (containerGroup) {
            let oiArray = newContainerIndex.split("_");
            if (oiArray.length > 1) {
              oiArray.splice(oiArray.length - 1, 1);
            }
            newContainerIndex = oiArray.join("_");
          }
          if (!originalIndex && !item.dynamicModule) {
            originalIndex = newContainerIndex;
          }
          if (!containerIndexArray.includes(newContainerIndex) && item.dynamicModule) {
            containerIndexArray.push(newContainerIndex);
          }
        });
      if (originalIndex == idmContainerId && containerIndexArray.length) {
        //更换初始
        const newOriginalIndex = containerIndexArray[0];
        copyModuleTree.children.forEach((item) => {
          if (
            item.containerIndex == newOriginalIndex ||
            (containerGroup && item.containerIndex.startsWiths(newOriginalIndex + "_"))
          ) {
            item.dynamicModule = false;
          }
        });
      }
      if (originalIndex) {
        containerIndexArray.push(originalIndex);
      }
      if (containerIndexArray.length == 1) {
        //只移除dom，不移除数据
        copyModuleTree.children.forEach((item) => {
          $("#router_page_" + this.routerId + " #" + item.packageid).remove();
        });
        return;
      }
      const removeAllPackageId = this.getModuleChildrenPackageId(
        packageid,
        idmContainerId,
        containerGroup
      );
      this.deletedDynamicModuleMap(removeAllPackageId);
      //删除树结构的
      copyModuleTree.children &&
        _.remove(copyModuleTree.children, function (n) {
          return (
            n.containerIndex == idmContainerId ||
            (containerGroup && n.containerIndex.startsWiths(idmContainerId + "_"))
          );
        });
    },
    /**
     * 递归删除map数据
     * @param {*} packageid 要删除的组件或者父级的组件
     * @param {*} ischildren 是否删除子组件
     * @param {*} containerIndex 要删除的容器下的直属索引，如果跨结构也直接删除
     */
    deletedDynamicModuleMap(removeAllPackageId) {
      var isdel = false;
      this.PageSettingData.page.componentsMap.forEach((item, index) => {
        if (removeAllPackageId.includes(item.packageid)) {
          isdel = true;
          this.PageSettingData.page.componentsMap.splice(index, 1);
          $("#router_page_" + this.routerId + " #" + item.packageid).remove();
        }
      });
      if (isdel) {
        this.deletedDynamicModuleMap(removeAllPackageId);
      }
    },
    /**
     * 查找汇总所有的组件包id
     * @param {*} moduleData 要查找的树结构
     * @param {*} allModulePackageId 存放所有的组件包ID变量
     * @param {*} setDynamicModule 是否设置组件属性dynamicModuleMessage = true;
     */
    findTreeAllModulePackageId(moduleData, allModulePackageId, setDynamicModule) {
      if (!(moduleData instanceof Array)) {
        moduleData = [moduleData];
      }
      moduleData.forEach((item) => {
        allModulePackageId.push(item.packageid);
        if (setDynamicModule) {
          item.dynamicModuleMessage = true;
        }
        item.children &&
          this.findTreeAllModulePackageId(
            item.children,
            allModulePackageId,
            setDynamicModule
          );
      });
    },
    /**
     * 刷新组件的主键以及赋值属性为动态渲染组件
     * @param {*} moduleData
     */
    refreshTreeModulePrimaryKey(
      moduleData,
      allModulePackageId,
      idmContainerId,
      containerGroup
    ) {
      if (!(moduleData instanceof Array)) {
        moduleData = [moduleData];
      }
      moduleData.forEach((item) => {
        //查找到map中的并拷贝一份修改id和packageid然后追加到map中
        let currentMapData = this.PageSettingData.page.componentsMap.filter(
          (sitem) => sitem.packageid == item.packageid
        );
        const modulePackageid = "component_" + IDM.uuid();
        item.packageid = modulePackageid;
        item.id = modulePackageid + "_inner";
        item.dynamicModule = true;
        let newCurrentMapData =
          currentMapData && currentMapData.length ? _.cloneDeep(currentMapData[0]) : {};
        newCurrentMapData.packageid = modulePackageid;
        newCurrentMapData.id = modulePackageid + "_inner";
        newCurrentMapData.dynamicModule = true;

        if (idmContainerId) {
          const ciArray = newCurrentMapData.containerIndex.split("_");
          if (containerGroup && ciArray.length > 1) {
            newCurrentMapData.containerIndex =
              idmContainerId + "_" + ciArray[ciArray.length - 1];
          } else {
            newCurrentMapData.containerIndex = idmContainerId;
          }
        }
        this.PageSettingData.page.componentsMap.push(newCurrentMapData);
        allModulePackageId.push(modulePackageid);
        item.children &&
          this.refreshTreeModulePrimaryKey(item.children, allModulePackageId);
      });
    },
    /**
     * 刷新组件树结构和map的globalid
     * @param {*} module 要刷新的树结构
     * @param {*} fmodule
     */
    refreshModuleAndMapGlobalId(module, fmodule) {
      if (!(module instanceof Array)) {
        module = [module];
      }
      var _findModule;
      module.forEach((item) => {
        item.globalId = fmodule.globalId + "." + item.packageid;
        //对map循环
        this.PageSettingData.page.componentsMap.forEach((sitem) => {
          if (item.packageid == sitem.packageid) {
            sitem.globalId = item.globalId;
          }
        });
        if (item.children) {
          this.refreshModuleAndMapGlobalId(item.children, item);
        }
      });
      return _findModule;
    },
    /**
     * 提供组件或组件内部容器的重新加载
     */
    moduleReload(packageid, innerContainerIndex) {
      //先查找模块，然后根据innerContainerIndex来删除对应的加载状态标识
      const reloadModule = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        packageid
      );
      let reloadModuleArray = [reloadModule];
      let parentModule;
      if (innerContainerIndex || innerContainerIndex == "0") {
        //存在内部索引
        reloadModuleArray = [];
        reloadModule &&
          reloadModule.children &&
          reloadModule.children.forEach((item) => {
            if (item.containerIndex == innerContainerIndex) {
              reloadModuleArray.push(item);
            }
          });
        parentModule = reloadModule;
      } else {
        //找出当前的父级
        let globalIdArray = reloadModule.globalId.split(".");
        const globalId =
          globalIdArray.length <= 2
            ? globalIdArray[0]
            : globalIdArray[globalIdArray.length - 2];
        parentModule = this.getModuleTree(
          this.PageSettingData.page.layout.children,
          globalId
        );
      }
      //删除全部加载状态
      this.resetLayoutInnerModuleLoadedStatus(reloadModuleArray);
      reloadModuleArray &&
        reloadModuleArray.forEach((item) => {
          $("#router_page_" + this.routerId + " #" + item.packageid).remove();
        });

      //调用重新加载
      this.initModuleTreeToPage(reloadModuleArray, true, parentModule, false);
    },
    /**
     * 组件挂载完成回调事件
     */
    moduleMountComplete(module) {
      let that = this;
      //把事件合并到map中
      this.PageSettingData.page.componentsMap.forEach((item) => {
        if (item.packageid == module.packageid) {
          item.idmBroadcastMessage = module.idmBroadcastMessage;
          item.idmSetContextValue = module.idmSetContextValue;
          item.idmGetContextValue = module.idmGetContextValue;
        }
      });
      console.log("挂载完成，回调返回的数据", module);
      let opModule = this.getModuleTree(
        this.PageSettingData.page.layout.children,
        module.packageid
      );
      //加载完成，不在加载中了
      opModule.loading = false;
      //设置加载完成的状态
      opModule.loaded = true;
      if (opModule.children && opModule.children.length > 0) {
        //有子组件，代表是容器类组件，首先获取是否加载完成且有子元素inner
        const targetNode = $("#" + module.packageid);
        if (targetNode.find(":visible").length == 0) {
          //代表内容元素还是空的，没有加载完成
          var invcount = 0;
          var intval = setInterval(function () {
            invcount++;
            if (
              $("#router_page_" + that.routerId + " #" + module.packageid).find(
                ":visible"
              ).length == 0 &&
              invcount <= 20
            ) {
              return;
            }
            clearInterval(intval);
            that.moduleMountCompleteCommon(module, opModule);
          }, 5);
        } else {
          //加载时序问题，延迟3毫秒
          setTimeout(() => {
            that.moduleMountCompleteCommon(module, opModule);
          }, 3);
        }
      } else {
        //加载时序问题，延迟3毫秒
        setTimeout(() => {
          that.moduleMountCompleteCommon(module, opModule);
        }, 3);
      }
      // this.initModuleInnerEventHandle(module);
      // class名称表示：
      // drag_container_empty：空容器类名
      // drag_container：容器，可拖拽过来
      // id作为class类名：样式设置
      // idm_module：所有组件最外层都有的类名
      // drag_container_inlineblock: 代表是行内容器

      // 属性 ：
      // idm-com-anchor-id：代表新生成的唯一组件ID
      // id:代表新生成的唯一组件ID
      // idm-com-id：组件的ID
      // idm-com-classid：组件的包名
      // idm-com-classname：组件的类名
      // idm-container-index：容器索引，在一个组件内有两个或以上的容器就会作用到
    },
    moduleMountCompleteCommon(module, opModule) {
      let that = this;
      var moduleDom = $("#router_page_" + this.routerId + " #" + module.packageid + "");
      var moduleInnerDom = moduleDom.find(">*[idm-ctrl]");
      var idmCtrl = moduleInnerDom.attr("idm-ctrl"),
        idmCtrlId = moduleInnerDom.attr("idm-ctrl-id"),
        domId = moduleInnerDom.attr("id");
      if (!domId) {
        moduleInnerDom.attr("id", idmCtrlId);
      }
      switch (idmCtrl) {
        case "drag_container": //容器
          moduleDom.addClass("drag_container");
          break;
        case "drag_container_inlineblock": //行内容器
          moduleDom.addClass("drag_container drag_container_inlineblock");
          break;
        case "idm_module": //非容器组件
          break;
      }

      //如果没有加载完成则先判断下，没有完成则继续加载
      if (!this.pageModuleDataIsLoaded(null, true)) {
        this.$nextTick(function () {
          this.initModuleTreeToPage(null, true, this.PageSettingData.page.layout);
        });
      } else if (this.pageModuleDataIsLoaded(null, true, "loaded")) {
        this.requestPageCommonInterfaceData(true);
      }
      //这里需要判断动态渲染是否已经消费完成 this.dynamicWaitExpendObject
      if (opModule.dynamicModule || opModule.dynamicModuleMessage) {
        //进行与 dynamicWaitExpendObject 获取判断
        let globalIdArray = opModule.globalId.split(".");
        const parentModuleId =
          globalIdArray[globalIdArray.length - 2] || globalIdArray[0];
        this.dynamicWaitExpendObject.forEach((ditem, index) => {
          if (
            globalIdArray.includes(ditem.packageid) &&
            ditem.allModulePackageId.includes(opModule.packageid)
          ) {
            let parentModuleTree = this.getModuleTree(
              this.PageSettingData.page.layout.children,
              ditem.packageid
            );
            //用ditem.allModulePackageId去判断是否已经全部加载完毕，如果全部加载完毕则需要给这些组件发送消息
            let allModulePackageId = _.cloneDeep(ditem.allModulePackageId);
            this.pageModuleDataIsLoaded(
              parentModuleTree.children,
              true,
              "loaded",
              allModulePackageId
            );
            if (allModulePackageId.length == 0) {
              //已经全部加载完毕，可以发送联动结果消息了 linkageResult
              IDM.broadcast.send({
                type: "linkageResult",
                message: ditem.itemData,
                rangeModule: ditem.allModulePackageId,
                messageKey: ditem.sendMessageKey || "dynamicRenderModule",
              });
              this.dynamicWaitExpendObject.splice(index, 1);
            }
          }
        });
      }
    },
    /**
     * 加载组件内部容器组件事件
     * 参数：
     * module：{packageid:组件包id，组件内部使用的id}
     */
    initModuleInnerEventHandle(module) {
      let that = this;
      //获取是否存在内部容器组件
      var moduleDom = $("#router_page_" + that.routerId + " #" + module.packageid + "");
      var moduleInnerDom = moduleDom.find(
        ".drag_container[idm-ctrl-id='" + module.id + "'][idm-ctrl-inner]"
      );
      if (moduleInnerDom.length > 0) {
        //内部组件重新追加，因为上面哪种加载方式会导致没加载完
        const opModule = this.getModuleTree(
          this.PageSettingData.page.layout.children,
          module.packageid
        );
        this.resetLayoutInnerModuleLoadedStatus(opModule.children);
        if (opModule.children && opModule.children.length > 0) {
          opModule.children.forEach((item) => {
            $("#" + item.packageid).remove();
          });
          this.initModuleTreeToPage(opModule.children, true, opModule);
        }
      }
    },
    /**
     * 加载前重置所有加载状态
     * @param {*} module
     * @param {*} resetModuleIdList
     */
    resetLayoutInnerModuleLoadedStatus(module, resetModuleIdList) {
      if (!(module instanceof Array)) {
        module = [module];
      }
      module.forEach((item) => {
        let hasFindLoadId =
          resetModuleIdList && resetModuleIdList.indexOf(item.packageid) > -1;
        let childrenResetModuleIdList = resetModuleIdList;
        if (!resetModuleIdList || hasFindLoadId) {
          //组件是否已经加载完成
          delete item.loaded;
          //组件是否在加载中...
          delete item.loading;
          //组件是否已经加载
          delete item.hasLoading;
          //组件的无载体容器属性
          delete item.nocontainer;
          if (hasFindLoadId) {
            item.againLoad = true;
            childrenResetModuleIdList = null;
          }
        }
        if (item.children && item.children.length > 0) {
          this.resetLayoutInnerModuleLoadedStatus(
            item.children,
            childrenResetModuleIdList
          );
        }
      });
    },

    addModuleEndpoint(module) {
      //判断是否需要加载连线
      let propData = this.PageSettingData.page.layout.props.compositeAttr || {};
      if (propData.openJsPlumb !== true) {
        return;
      }
      var common = {
        isSource: true,
        isTarget: true,
        endpoint: "Dot",
      };
      let _basicAttr =
        module.props && module.props.basicAttr
          ? module.props && module.props.basicAttr
          : {};
      let offsetsTop = [0, 0],
        offsetsTopRight = [0, 0],
        offsetsRight = [0, 0],
        offsetsBottomRight = [0, 0],
        offsetsBottom = [0, 0],
        offsetsBottomLeft = [0, 0],
        offsetsLeft = [0, 0],
        offsetsTopLeft = [0, 0];
      if (_basicAttr.AnchorsTopLeft) {
        offsetsTop = _basicAttr.AnchorsTop.split(",");
        offsetsTopRight = _basicAttr.AnchorsTopRight.split(",");
        offsetsRight = _basicAttr.AnchorsRight.split(",");
        offsetsBottomRight = _basicAttr.AnchorsBottomRight.split(",");
        offsetsBottom = _basicAttr.AnchorsBottom.split(",");
        offsetsBottomLeft = _basicAttr.AnchorsBottomLeft.split(",");
        offsetsLeft = _basicAttr.AnchorsLeft.split(",");
        offsetsTopLeft = _basicAttr.AnchorsTopLeft.split(",");
      }
      debugger;
      //基本属性里面直接填写8个点的偏移值
      let endpointList = [
        {
          anchor: [0.5, 0, 0, -1, parseFloat(offsetsTop[0]), parseFloat(offsetsTop[1])],
          cssClass: module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-top",
        },
        {
          anchor: [
            1,
            0,
            0,
            -1,
            parseFloat(offsetsTopRight[0]),
            parseFloat(offsetsTopRight[1]),
          ],
          cssClass:
            module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-top-right",
        },
        {
          anchor: [
            1,
            0.5,
            1,
            0,
            parseFloat(offsetsRight[0]),
            parseFloat(offsetsRight[1]),
          ],
          cssClass: module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-right",
        },
        {
          anchor: [
            1,
            1,
            0,
            1,
            parseFloat(offsetsBottomRight[0]),
            parseFloat(offsetsBottomRight[1]),
          ],
          cssClass:
            module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-bottom-right",
        },
        {
          anchor: [
            0.5,
            1,
            0,
            1,
            parseFloat(offsetsBottom[0]),
            parseFloat(offsetsBottom[1]),
          ],
          cssClass: module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-bottom",
        },
        {
          anchor: [
            0,
            1,
            0,
            1,
            parseFloat(offsetsBottomLeft[0]),
            parseFloat(offsetsBottomLeft[1]),
          ],
          cssClass:
            module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-bottom-left",
        },
        {
          anchor: [0, 0.5, -1, 0, parseFloat(offsetsLeft[0]), parseFloat(offsetsLeft[1])],
          cssClass: module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-left",
        },
        {
          anchor: [
            0,
            0,
            0,
            -1,
            parseFloat(offsetsTopLeft[0]),
            parseFloat(offsetsTopLeft[1]),
          ],
          cssClass:
            module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-top-left",
        },
        // { anchor: "Center", cssClass: module.packageid + "_endpoint idm_flow_endpoint " + "endpoint-center" },
      ];
      this.plumbIns.addEndpoints(module.packageid, endpointList, common);
    },
    /**
     * 连线样式改变
     * @param {*} linkObject
     */
    linkConnectionStyleChange(_linkObject) {
      let that = this;
      const linkFilterList = this.PageSettingData.page.linkList.filter(
        (item) => item.id == _linkObject.id
      );
      if (!linkFilterList.length) {
        return;
      }
      const linkObject = linkFilterList[0];
      let linkPropData = linkObject.propData;
      this.plumbIns.select().each((connection) => {
        if (connection.id == linkObject.connId) {
          if (linkPropData.linkType) {
            let connectorParam = [linkPropData.linkType];
            switch (linkPropData.linkType) {
              case "Bezier":
                connectorParam[1] = {
                  curviness:
                    linkPropData.BezierCurviness || linkPropData.BezierCurviness == 0
                      ? linkPropData.BezierCurviness
                      : 150,
                };
                break;
              case "Straight":
                connectorParam[1] = {
                  stub:
                    linkPropData.StraightStub || linkPropData.StraightStub == 0
                      ? linkPropData.StraightStub
                      : 0,
                  gap:
                    linkPropData.StraightGap || linkPropData.StraightGap == 0
                      ? linkPropData.StraightGap
                      : 0,
                };
                break;
              case "Flowchart":
                connectorParam[1] = {
                  stub:
                    linkPropData.FlowchartStub || linkPropData.FlowchartStub == 0
                      ? linkPropData.FlowchartStub
                      : 30,
                  gap:
                    linkPropData.FlowchartGap || linkPropData.FlowchartGap == 0
                      ? linkPropData.FlowchartGap
                      : 2,
                  alwaysRespectStubs: true,
                  cornerRadius:
                    linkPropData.FlowchartCornerRadius ||
                    linkPropData.FlowchartCornerRadius == 0
                      ? linkPropData.FlowchartCornerRadius
                      : 8,
                  midpoint:
                    linkPropData.FlowchartMidpoint || linkPropData.FlowchartMidpoint == 0
                      ? linkPropData.FlowchartMidpoint
                      : 0,
                };
                break;
              case "StateMachine":
                connectorParam[1] = {
                  curviness:
                    linkPropData.StateMachineCurviness ||
                    linkPropData.StateMachineCurviness == 0
                      ? linkPropData.StateMachineCurviness
                      : 10,
                  margin:
                    linkPropData.StateMachineMargin ||
                    linkPropData.StateMachineMargin == 0
                      ? linkPropData.StateMachineMargin
                      : 5,
                  proximityLimit:
                    linkPropData.StateMachineProximityLimit ||
                    linkPropData.StateMachineProximityLimit == 0
                      ? linkPropData.StateMachineProximityLimit
                      : 80,
                };
                break;
            }
            connection.setConnector(connectorParam);
          }
          let PaintStyle = _.cloneDeep(jsplumbConfig.ins.PaintStyle);
          if (linkPropData.PaintStyleStroke && linkPropData.PaintStyleStroke.hex8) {
            PaintStyle.stroke = linkPropData.PaintStyleStroke.hex8;
          }
          if (linkPropData.PaintStyleStrokeWidth) {
            PaintStyle.strokeWidth = linkPropData.PaintStyleStrokeWidth;
          }
          connection.setPaintStyle(PaintStyle);
          let HoverPaintStyle = _.cloneDeep(jsplumbConfig.ins.HoverPaintStyle);
          if (
            linkPropData.HoverPaintStyleStroke &&
            linkPropData.HoverPaintStyleStroke.hex8
          ) {
            HoverPaintStyle.stroke = linkPropData.HoverPaintStyleStroke.hex8;
          }
          if (linkPropData.HoverPaintStyleStrokeWidth) {
            HoverPaintStyle.strokeWidth = linkPropData.HoverPaintStyleStrokeWidth;
          }
          connection.setHoverPaintStyle(HoverPaintStyle);
          //先全部移除再重新设置
          connection.removeAllOverlays();
          linkPropData.overlayList &&
            linkPropData.overlayList.forEach((overlayItemData) => {
              let overlayParam = { id: overlayItemData.overlayId };
              if (
                overlayItemData.location &&
                overlayItemData.location.split(",").length > 1
              ) {
                const oosp = overlayItemData.location.split(",");
                overlayParam.location = [parseFloat(oosp[0]), parseFloat(oosp[1])];
              } else if (overlayItemData.location) {
                overlayParam.location = parseFloat(overlayItemData.location);
              }
              overlayParam.direction = overlayItemData.direction || 1;
              switch (overlayItemData.type) {
                case "Arrow":
                case "PlainArrow":
                case "Diamond":
                  if (overlayItemData.arrowSize) {
                    const arrowSizeObject = overlayItemData.arrowSize.split(",");
                    if (arrowSizeObject.length > 0) {
                      overlayParam.width = parseFloat(arrowSizeObject[0]);
                      overlayParam.length = parseFloat(arrowSizeObject[0]);
                    }
                    if (arrowSizeObject.length > 1) {
                      overlayParam.length = parseFloat(arrowSizeObject[1]);
                    }
                  }
                  break;
                case "Label":
                  overlayParam.label = overlayItemData.labelText;
                  let labelStyle = {};
                  if (overlayItemData.font) {
                    labelStyle.font = overlayItemData.font;
                  }
                  if (
                    overlayItemData.padding &&
                    overlayItemData.padding.inputVal &&
                    overlayItemData.padding.selectVal
                  ) {
                    labelStyle.padding =
                      overlayItemData.padding.inputVal +
                      overlayItemData.padding.selectVal;
                  }
                  if (overlayItemData.borderWidth) {
                    labelStyle.borderWidth = overlayItemData.borderWidth;
                  }
                  if (overlayItemData.fillStyle && overlayItemData.fillStyle.hex8) {
                    labelStyle.fill = overlayItemData.fillStyle.hex8;
                  }
                  if (overlayItemData.color && overlayItemData.color.hex8) {
                    labelStyle.color = overlayItemData.color.hex8;
                  }
                  if (overlayItemData.borderStyle && overlayItemData.borderStyle.hex8) {
                    labelStyle.borderStyle = overlayItemData.borderStyle.hex8;
                  }
                  overlayParam.labelStyle = labelStyle;
                  overlayParam.cssClass = "idm-overlay-label";
                  break;
                case "Custom":
                  if (
                    overlayItemData.contentFunction &&
                    overlayItemData.contentFunction.length > 0
                  ) {
                    overlayParam.create = function (component) {
                      //这里处理自定义的事件
                      //const d = document.createElement("span")
                      //d.innerHTML = "请预览看效果"
                      return that.commonCustomEventFunHandle(
                        overlayItemData,
                        "contentFunction",
                        { component, overlaySetData: overlayItemData }
                      );
                    };
                  } else {
                    return;
                  }
                  break;
              }
              if (
                overlayItemData.clickFunction &&
                overlayItemData.clickFunction.length > 0
              ) {
                overlayParam.events = {
                  click: (event, overlay) => {
                    //这里处理自定义的事件
                    that.commonCustomEventFunHandle(overlayItemData, "clickFunction", {
                      event,
                      overlay,
                      overlaySetData: overlayItemData,
                    });
                  },
                };
              }
              connection.addOverlay([overlayItemData.type, overlayParam]);
            });
        }
      });
    },
    /**
     * 重连
     */
    reconnectionAllModule() {
      let that = this;
      let existsLink = this.plumbIns.select();
      that.PageSettingData.page.linkList.forEach((linkObject) => {
        let isExists = false;
        try {
          existsLink.each((connection) => {
            if (connection.endpoints && connection.endpoints.length > 1) {
              if (
                connection.endpoints[0].anchor.x == linkObject.sourceEndpoint.x &&
                connection.endpoints[0].anchor.y == linkObject.sourceEndpoint.y &&
                connection.endpoints[1].anchor.x == linkObject.targetEndpoint.x &&
                connection.endpoints[1].anchor.y == linkObject.targetEndpoint.y
              ) {
                isExists = true;
              }
            }
          });
        } catch (error) {}
        if (!isExists) {
          // sourceEndpoint
          let param = {
            // source:linkObject.sourceId,
            // target:linkObject.targetId,
            source: that.getModuleEndpoint(
              linkObject.sourceId,
              linkObject.sourceEndpoint.x,
              linkObject.sourceEndpoint.y
            ),
            target: that.getModuleEndpoint(
              linkObject.targetId,
              linkObject.targetEndpoint.x,
              linkObject.targetEndpoint.y
            ),
            parameters: {
              isreconnection: true,
              linkObjectId: linkObject.id,
            },
          };
          that.plumbIns.connect(param);
          //根据属性去修改样式
          that.linkConnectionStyleChange(linkObject);
        }
      });
    },
    /**
     * 根据组件和坐标获取Endpoint对象
     * @param {*} packageid
     * @param {*} x
     * @param {*} y
     * @returns
     */
    getModuleEndpoint(packageid, x, y) {
      let rtnEndpoint = null;
      this.plumbIns.selectEndpoints({ source: packageid }).each((endpoint) => {
        if (rtnEndpoint) {
          return;
        }
        if (endpoint.anchor.x == x && endpoint.anchor.y == y) {
          rtnEndpoint = endpoint;
        }
      });
      return rtnEndpoint;
    },
    initJsPlumb() {
      let that = this;
      this.plumbIns = jsPlumb.getInstance(jsplumbConfig.ins);
      this.plumbIns.ready(function () {
        that.plumbIns.setContainer("idm_hover_layer_wrap");
      });
      this.plumbIns.bind("connection", function (conn, e) {
        let parameters = conn.connection.getParameters();
        if (parameters && parameters.isreconnection) {
          //代表是重连的，需要设置对应的id等
          let filterList = that.PageSettingData.page.linkList.filter(
            (item) => item.id == parameters.linkObjectId
          );
          if (filterList.length > 0) {
            conn.connection.canvas.id = filterList[0].canvasId;
            conn.connection.id = filterList[0].connId;
          }
          return;
        }
      });
    },
  },
};
</script>

<style></style>
